import { ModalystStaffPick } from '../types/products';

export const DUMMY_STAFF_PICKS: ModalystStaffPick[] = [
  {
    id: '58e0a5b7-71f2-4908-9e4e-cc5bcd964396',
    name: 'Oatmeal & Goat Milk Handmade Soap',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c3/14/c314843234dae3c8c11baa044c2eea86.png',
    cost_min: '2.70',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '03e35462-f6f3-4424-9774-ec87b38efe1f',
    name: 'Pablo Picasso Dove of Peace 1949 Artwork T-Shirt',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/44/62/4462e475e8e6507bd7d6a283d317cef5.png',
    cost_min: '13.17',
    categories: ['rts.mensFashion'],
  },
  {
    id: 'cd2d7cd9-a633-4006-9509-25ecb3037e55',
    name: 'Mye1038 - Fan Shape Drop Hoop Earrings',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d6/41/d641f81c91e1221ec79afcf8ac685047.jpg',
    cost_min: '4.95',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'a4a09dc7-3185-40a3-8355-e74310716f40',
    name: 'BSport – Bluetooth Sport Headphones With Dual-Microphone and NFC',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d4/f5/d4f57b382de4b1cef32c5b030a498753.jpg',
    cost_min: '11.99',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: 'ed380a08-3c99-4c8a-9889-bab6ca04bee9',
    name: "Andy Warhol's Banana, 1967 Pop Art T-Shirt",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/4f/bf/4fbf4ff745af583a481ec3bb6b134555.png',
    cost_min: '13.17',
    categories: ['rts.mensFashion'],
  },
  {
    id: '882e36f7-fba7-40ee-8d84-ee77dea101b4',
    name: 'Mineral (Baking Soda-Free) Deodorant',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/44/e3/44e397a90383cbde9e4a2b921d085e18.jpg',
    cost_min: '5.99',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '1894e343-d747-4bbb-9137-0097029a9db7',
    name: 'Grapefruit Splash- Grapefruit Scented Handmade Soap',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/3e/7c/3e7c70dccb4c2176fb393aedb3d126cc.png',
    cost_min: '2.70',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'a4894d21-3467-4483-9a50-26825f1c9653',
    name: 'Kanye West Albums Minimal',
    staff_picks: ['category_pick', 'bestseller'],
    image: 'https://media.modalyst.co/cache/e3/60/e360313194ba7fda5c17dbdee6e8c9a6.jpg',
    cost_min: '10.20',
    categories: ['rts.homeGarden'],
  },
  {
    id: 'e7f59821-341d-416e-9cb9-0ef9c5882020',
    name: 'Cheek Flush (Talc-Free)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/7e/a7/7ea737f372a54f8fa91509e1f14b9c54.jpg',
    cost_min: '7.20',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '4af26b3c-5b2d-4c36-a782-1541715633ff',
    name: 'BeardGuru AppleBlossom Beard Oil',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/22/71/22714f6fbde831c38be4df8fc108bc53.jpg',
    cost_min: '13.79',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '74fed2e1-d156-4ca4-8406-86fb3a328794',
    name: 'Bambini Infant White Gown',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/83/35/8335734c543d354f8abc0f6505ef20df.jpg',
    cost_min: '4.19',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'a87ef190-04c8-441f-81a5-72db992782ee',
    name: 'Lustrao Hair Regrowth Oil',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d9/75/d97589d65dbaa2c26fe8eed09a68b8ef.png',
    cost_min: '16.19',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '4897e990-b5e7-48d1-9f6d-b861122a8cfe',
    name: 'Pendleton X Yune Yoga Spider Rock Mat',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/99/a7/99a7d47549fe11d6196a37acb90ebd8d.jpg',
    cost_min: '39.00',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '721b545d-ba3a-49c3-801f-20fed1fc49c1',
    name: 'Geometric Open Circle Ring',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/49/49/49499b0d0696860a0e2fa0c4302df474.jpg',
    cost_min: '36.00',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '5ccd90de-8bf8-49de-ba98-dc5cf6cd6f83',
    name: 'Relax Sequin Cushion Cover',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d2/cf/d2cf55931176df5b674b8c2476a71623.png',
    cost_min: '13.19',
    categories: ['rts.homeGarden'],
  },
  {
    id: '63f11225-8b92-4d14-bac8-576b50defffc',
    name: 'Flip-Flops Model 198287 Step in Style',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c6/ac/c6ac7b5b2481039ced1b6a60ba26cdf7.jpg',
    cost_min: '11.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '61b240a4-f57e-4481-b9ab-2b45b33db95f',
    name: 'Iimo 3-In-1 Foldable Tricycle With Canopy',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/30/a2/30a25aa3ba5e5be7626b796e69ab6b8a.jpg',
    cost_min: '196.00',
    categories: ['rts.toysHobbies'],
  },
  {
    id: '87c464d0-8deb-47fe-bd52-1810f74a6614',
    name: 'Sultan Peshkir Turkish Towels',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d3/73/d3730df81c7f8290c70860222b45c155.png',
    cost_min: '7.79',
    categories: ['rts.homeGarden'],
  },
  {
    id: '0ee010c3-642f-45d4-8aec-52b3b72f7042',
    name: 'Cami With Lace Trim White and Fuchsia',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/22/6b/226b6fa41f62308b02612233a788991a.jpg',
    cost_min: '32.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: '3afce4e2-58a8-4257-9213-93eeca4837eb',
    name: 'Vitamin C Repairing Oil',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/8b/a3/8ba372e4e69df9d0ec2c2b625ce2b459.png',
    cost_min: '11.99',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '080004d2-e3c2-4f9a-b725-0b34c4ee0e68',
    name: 'Grade a Amethyst Druzy Crystals',
    staff_picks: ['category_pick', 'bestseller'],
    image: 'https://media.modalyst.co/cache/ef/5e/ef5e07515e3c9ebecf569a503c19728b.jpg',
    cost_min: '4.80',
    categories: ['rts.homeGarden'],
  },
  {
    id: '93cd8c7a-c12c-4bc2-a8c3-de72cd6b365e',
    name: 'Denim Jacket With Star Embellishment in Midwash',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/5f/1b/5f1b1cfbfb6e6f4a158e16d6cd64ebcc.jpg',
    cost_min: '50.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: '231ca3d0-580b-4e17-91b6-b3852155a769',
    name: 'Beeing - The Cutting-Edge True Wireless Earbuds With Qi-Enabled Wireless Charging Case',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/10/5a/105ad37d58c1c34f5ea76f968557233e.jpg',
    cost_min: '35.99',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: '9d9c434d-5517-4a7e-b1ac-0cd080c654b8',
    name: 'MTR-8748 Navy',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/64/6f/646fc0a0cf007dbbc6c21049f703fbb3.jpg',
    cost_min: '18.62',
    categories: ['rts.mensFashion'],
  },
  {
    id: 'dcdcfc28-7dcf-47cc-9ff9-bd4d12bcb6e8',
    name: 'Lammy Plush Rattle by Happy Horse',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/eb/13/eb134a9b3b19022fb7d7181f3400a7a9.jpg',
    cost_min: '9.60',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '91a41875-a653-4ce8-9dda-d5df605b5a10',
    name: 'Tesla Fridge 193Wh Portable Power Station',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/4b/ab/4babc0a9d32adadc5ab3db4a064350d4.jpg',
    cost_min: '159.60',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: '4b0e72ab-22e3-4aed-9db5-32f6842b5686',
    name: 'Banksy Anarchist Punk and His Mother Artwork T-Shirt',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2d/78/2d78f602d3bf42cf432bbf6f0365fdb5.png',
    cost_min: '13.17',
    categories: ['rts.mensFashion'],
  },
  {
    id: '787a7508-de25-49ea-b5c7-079ccbb1c973',
    name: "Save Ferris From Ferris Bueller's Day Off T-Shirt",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d9/c6/d9c6875248c9535c3c4fe240d5df6fec.png',
    cost_min: '13.17',
    categories: ['rts.mensFashion'],
  },
  {
    id: '61122b8b-a0af-4a5b-aeb1-854effc54f7d',
    name: 'Amity Island Surf Shop, Jaws T-Shirt',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/76/cb/76cb0f1f7fdaaaa8a68d9b7c8d982bd0.png',
    cost_min: '13.17',
    categories: ['rts.mensFashion'],
  },
  {
    id: 'f9f08587-5ce6-4bd8-b864-06c146fa5316',
    name: 'Find Your Coast® Heritage Sunset Explorer Hoodie',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/1c/7f/1c7ffad5c2d10a28880a1b1fad0e618d.png',
    cost_min: '47.40',
    categories: ['rts.mensFashion'],
  },
  {
    id: '8c856ae0-ccd2-429b-adaf-538af3f9fe6a',
    name: 'Laundry Detergent Strips',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/cb/e4/cbe4a9764d8e20f98ff02e4627099404.jpg',
    cost_min: '12.27',
    categories: ['rts.homeGarden'],
  },
  {
    id: '5b6e8fdc-519c-4f62-9f0e-3d352dc45c74',
    name: 'Convoy S2+ Black  XML2 U2-1a AMC7135*3  2-Group 3/5-Mode EDC LED Flashlight',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/10/4a/104ab27773e022ff79d62bf22975a911.jpg',
    cost_min: '13.71',
    categories: ['rts.homeGarden'],
  },
  {
    id: 'd5542416-c060-48ec-a7f2-2c6e412840a0',
    name: 'Linen Mens Shorts Newest Summer Casual Shorts Men Cotton Fashion Men Short Bermuda Beach Short Plus Size 4XL Joggers Male Hot',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/d5/83/d583a692876e12efa964fb951d446f30.jpg',
    cost_min: '15.69',
    categories: ['rts.mensFashion'],
  },
  {
    id: '5b0f5b73-356b-4c20-bd40-aa6c6309286c',
    name: 'Face Mask',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c7/19/c719fa980a650bbc3427f2523626cff2.png',
    cost_min: '11.99',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '5ab6aad8-e7dc-40f7-a99f-b2cd2db9e691',
    name: 'Aftershave Serum Bundle (5-Pack)',
    staff_picks: ['category_pick', 'bestseller'],
    image: 'https://media.modalyst.co/cache/75/5a/755ac8daf3f7c261fdd549fe9b282039.jpg',
    cost_min: '41.39',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '6c94c1d6-dcba-413d-be54-aa7d5a7b9411',
    name: 'BT Mobile Head Phones Over Ear Phone Stereo Music Headset Over-Ear Headphones',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/dc/61/dc61cb6d25077ece25d8bf0f5d740a86.jpg',
    cost_min: '11.99',
    categories: [],
  },
  {
    id: 'b1907ac1-d1b7-4d5d-8f52-f54b1014f71b',
    name: 'Twist Cross Floral Elastic Knotted Headband',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d4/46/d4469c82c00462ff092078a1b0450ed7.jpg',
    cost_min: '13.02',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'f465eb28-2165-46c9-81ea-ade1b4c67e74',
    name: "Women's CoastFlex Turtle Bay Capri Leggings",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/de/07/de075e54135e9f9da3679f25a392ffe3.png',
    cost_min: '36.00',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: 'ca0f74e7-e760-42c9-ac69-a13813f1d6b5',
    name: 'CoastFlex Sport Olivia II Leggings',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/9c/e5/9ce5034c3ff6ae9c2b14fc1c209e7661.png',
    cost_min: '48.00',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '4a1199b5-ea43-4d60-8ef4-095233cf6fed',
    name: 'Rose Gold Crystal Elixir Water Bottle With Tea Infuser 500ML',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f5/03/f5039e3234e3374157185d52fedae2eb.png',
    cost_min: '21.59',
    categories: ['rts.homeGarden'],
  },
  {
    id: '373157b3-b693-4c6c-a4de-65507f408992',
    name: 'Advanced Skin Regimen Kit (5-Piece Set)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/91/6a/916a07ecff5156b149363b1dc0782ca1.jpg',
    cost_min: '35.39',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '4709560d-c7c7-4817-9b3a-df444e5b57c9',
    name: 'Salt Scrub (Multiple Sizes)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c9/b9/c9b970858a7899ceab5946303fd8fb55.jpg',
    cost_min: '10.19',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '07ebb848-f56b-4a21-b1f0-0cacd16ef325',
    name: 'Essentials Skin Regimen Kit (4-Piece Set)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/45/8d/458d2342f5794d1dca90021667a6369c.png',
    cost_min: '23.99',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '9950588e-2c3a-4c92-89f4-76b7c7cc964d',
    name: 'Dish Soap Block',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ce/48/ce48263bcff9a2c3cad47c45eb79bfbb.jpg',
    cost_min: '8.39',
    categories: ['rts.homeGarden'],
  },
  {
    id: '3fbfcd8f-9447-43c5-9621-abaac14b6ddc',
    name: 'Causal Hobo Bag for Women Vegan Leather With Crossbody Long Strap in Tan, Blue, Grey, Black',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/50/15/5015c8c0e6f2f28de3091cc28f8a25ea.jpg',
    cost_min: '41.94',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: '89d862ee-8fda-4857-a0cb-affb8d5cd383',
    name: '100% Cotton Short Sleeve Fucus Printed Tshirt',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2e/cc/2eccc8d6dce42a1da1aeaa2b3d07a2aa.jpg',
    cost_min: '20.39',
    categories: ['rts.mensFashion'],
  },
  {
    id: '9df6e5c5-686a-4a12-9b0e-718773a0d6f1',
    name: 'Natural Handcrafted Grey Himalayan Salt Lamp 1.5-5kg',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/5f/c9/5fc9ff92bdef9d14b7cd9d781663bd20.png',
    cost_min: '16.79',
    categories: ['rts.homeGarden'],
  },
  {
    id: '5dfd173b-a36e-41dc-8adc-21156f043dfe',
    name: 'Hair Serum',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ad/97/ad97d6bc0a7078ccbe3527dd7c86a24a.png',
    cost_min: '16.79',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '23eea3da-498c-489e-b8e6-ed9ab633c22f',
    name: 'Kitchen Accessories Metal White Foldable Kitchen  Frying Pan Oil  Prevent Protection Screen Kitchen Stove Baffle Plate',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/87/f8/87f803d20b03949bda476766048e0655.jpg',
    cost_min: '6.90',
    categories: [],
  },
  {
    id: '09f49cca-244f-4d4d-b880-26292aedab4c',
    name: 'The Endless Summer 1966 Surf Documentary T-Shirt',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/53/45/534592c59fe11ec07698865f27f5abf4.png',
    cost_min: '13.17',
    categories: ['rts.mensFashion'],
  },
  {
    id: '8e09d250-f7e6-4f25-909b-9e072e8408f9',
    name: 'Ultra Thin Power Bank for MagSafe,Magnetic Wireless Fast Charging LED Display Portable Battery for iPhone Samsung Phone Airpods',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/b4/0c/b40c5681e08aca9a45c373b476e889f6.jpg',
    cost_min: '24.09',
    categories: [],
  },
  {
    id: '55ce2362-41cf-4b8c-b2db-7fb8174dd1e1',
    name: 'Tuya Smart Home Security Camera Indoor Smart Wifi Baby Camera',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2f/87/2f874508b864db9edf928625a0858c64.jpg',
    cost_min: '18.00',
    categories: [],
  },
  {
    id: '3c2776d6-cdae-4ef1-8125-0aaeeb0d6175',
    name: 'Shave Brush',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/1c/01/1c0120f047bebeb5fcc08ddecac05a8d.jpg',
    cost_min: '6.59',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'b607c22d-f838-45f3-8348-b2188d2d448a',
    name: 'Bambini Receiving Blanket',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f5/5a/f55a0c99af947b0c37a0a8dc63aa7fbf.jpg',
    cost_min: '5.39',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '88b4441e-04e4-4f4a-a3cd-e808e66dfcf3',
    name: 'Natural Loofah Pad 2-Pack',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/8e/45/8e45b5ab3ecdea1f23b56a152e7dcb7d.png',
    cost_min: '5.99',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'dcc37698-e1bb-49e2-bcbc-4c8e55d06a05',
    name: 'Eucalyptus Radiata  Pure Essential OIl-15ml',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a1/f7/a1f74232576c950f04165ef8ef7cff14.jpg',
    cost_min: '8.40',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '279320ab-b0e3-4ef0-947d-6455e4f8036d',
    name: 'Oak Wood Phone Case',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/aa/b4/aab4f65a46b5f5ceaa04f38c6c601615.jpg',
    cost_min: '22.38',
    categories: ['rts.cellphonesTelecommunications'],
  },
  {
    id: '53e942d7-de81-4e46-843a-bd1ba42a8e4f',
    name: 'Vintage Flower Tropical Leaves Cushion Cover',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/9d/c2/9dc22ebe47f71dfd4adfa778701f4d1a.jpg',
    cost_min: '13.92',
    categories: ['rts.homeGarden'],
  },
  {
    id: '8531a862-53ba-4909-a31b-21c82815e9f8',
    name: 'HATLANDER Camouflage Snapback Polyester Cap Blank Flat Camo Baseball Cap With No Embroidery Mens Cap and Hat for Men And',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ec/1e/ec1ec3a2403fdd3ffe27ad9149fbb02a.jpg',
    cost_min: '31.56',
    categories: ['rts.mensFashion'],
  },
  {
    id: '735510f2-09da-4f77-aae8-95480dad199f',
    name: 'VR Shinecon 10.0 Helmet 3D Glasses Virtual Reality Casque for Smartphone Smart Phone Goggles Headset Viar Video Game Binoculars',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/15/f6/15f690e37d4601a4efaea29c5634831e.jpg',
    cost_min: '31.36',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: '2ee2472c-48d8-470c-a812-fe44d4cd215c',
    name: 'Tuya Zigbee Wifi Smoke Detector Sensor 80DB Alarm Fire Smart Smoke Detector Wifi Fire Protection Home Security Alarm Smart Life',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/57/bb/57bbb949916f6687d5820356499df508.jpg',
    cost_min: '10.82',
    categories: [],
  },
  {
    id: '7803470a-9267-41c2-8e1c-e38531023c67',
    name: 'Faux Fur Long Casual Coat',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e1/e0/e1e01b0ed9ab2227ebd0b69ff0b1a389.jpg',
    cost_min: '69.48',
    categories: ['rts.womensFashion'],
  },
  {
    id: '83ef3b8b-8bc3-44f7-9d39-fad576d297c4',
    name: '128G R36S Retro Handheld Video Game Console Linux System 3.5 Inch IPS Screen R35s Pro Portable Pocket Video Player 64GB Games',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/7d/d5/7dd5cee163d188ec6a89d85d4def051e.jpg',
    cost_min: '53.81',
    categories: [],
  },
  {
    id: 'd80b2f1a-86de-4fd4-baed-bd8cb501a03c',
    name: 'Rebel Beard Oil',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/4b/05/4b058ef34fb46f97f01e500613644674.jpg',
    cost_min: '13.79',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '9d955236-a19c-4cfd-ac08-a074c43b5896',
    name: 'BeardGuru AppleBlossom Beard Balm',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/94/1f/941f92de0dc4cfb0699c978b4931e3a3.jpg',
    cost_min: '14.39',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '47c563f1-1649-43e4-8209-388a4e878f4b',
    name: 'Turmeric & Honey Handmade Soap',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/06/f2/06f2eb92ed5a233e687387681c7c3598.png',
    cost_min: '2.70',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'd44c6cc7-ae76-478b-8f37-27a57903563d',
    name: 'Bamboo Charcoal Detox Handmade Soap Bar',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/94/b3/94b3329c1f9e960e9d98a9a7a80c5cb6.png',
    cost_min: '2.70',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '648ae142-3aa6-4fed-b36e-2b41b57610c6',
    name: 'Backpack Purse for Women Utility Big Backpack Purse Vegan Leather Antique Tone',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c5/61/c5611df91f51624ed53abead15edf681.jpg',
    cost_min: '41.21',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: '7905e13b-804b-4b92-baf6-df87fd285af6',
    name: 'Silver Mountain Necklace',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/de/71/de71c5bc14b8c97d348d0d5871fc315b.jpg',
    cost_min: '23.40',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'db56d4d3-5f9b-4804-8470-2cb0c284a25b',
    name: 'Mama Bear and Cub Necklace',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/17/3d/173dd3d88a369cbb9d653c54218cd42c.jpg',
    cost_min: '23.40',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '59458e49-a3af-4314-80f2-8416812475f2',
    name: 'Luxury Alligator Leather Handbags',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/97/11/971154bcad85803be2016882a03d099f.jpg',
    cost_min: '56.89',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: '15b0d2f3-8d17-44bb-b202-bc7fa0e4395f',
    name: 'Luxury Leather Bucket Acrylic Handle Shoulder Bag',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/69/b3/69b3a316fd84f46611dad33a13dec6d1.jpg',
    cost_min: '50.18',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: '9fe7e77e-697a-437e-ac36-e72626b2428b',
    name: 'Find Your Coast® Palm Soul Open Shoulder A-Line Dress',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/47/47/47477bc0524fb88f4e8d0929c9e8818c.jpg',
    cost_min: '53.40',
    categories: ['rts.womensFashion'],
  },
  {
    id: '6c07275c-d9a2-47ee-b986-121732bf6765',
    name: 'Hydrating Shampoo',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/8a/cb/8acb421c1e0ddee0210f09a3e4a8e073.webp',
    cost_min: '11.40',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'd56e6998-ee12-4118-b5f8-95d489fde1a4',
    name: 'Hydrating Shampoo &amp; Conditioner',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a5/bc/a5bc6eaebf65a636f8a9d761bf1d515c.webp',
    cost_min: '16.80',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'a2127943-2e82-44d1-91af-39401dd0abfd',
    name: "Bambini Girl's Printed Tank Top",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/59/57/595773526716c9e004f07e521faf6d30.jpg',
    cost_min: '6.59',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '03a0a3c6-a153-440a-b979-8bab6bec3f1e',
    name: 'Baby Onesie - Mexican Dancing Dinosaur With Sombrero',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/cc/62/cc627e2df3055ab344cf64f3faa4f1b7.jpg',
    cost_min: '22.80',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '786f88c2-90bb-4adf-884e-3619cb8f6650',
    name: 'Bambini Fleece Robe With Hoodie',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/4a/d2/4ad22daecc2fe15954b8860a4395b7ad.jpg',
    cost_min: '5.99',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'a0951ae3-ca8e-4bfc-aad2-8444c15bdbdf',
    name: 'Geometric Cactus & Succulent Planter',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/05/5b/055b67233481c90c90446a0ece8b550d.jpg',
    cost_min: '36.00',
    categories: ['rts.homeGarden'],
  },
  {
    id: '83a719db-fa62-44c0-9d6a-d21c55cc9913',
    name: 'A Wild Boy & a Wild Monster Infant Bodysuits Combo',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/fd/53/fd53867e738e116f93834e8d7ee8e8bd.jpg',
    cost_min: '31.80',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '946a676d-c414-4c1b-bdbb-286b00ec8dae',
    name: 'Baby Onesie - Looks Like Mr. Tee',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/2e/4d/2e4d0863aae3001edd52d1fdc9c43eb1.png',
    cost_min: '21.60',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '35d35375-fd60-46c8-aea9-45b1a3eceab2',
    name: 'RBG - Infant Bodysuit - Gray',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c4/73/c473ee0deb7808397cb0d9429097e191.png',
    cost_min: '22.80',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'eeabf9f3-43bb-42b8-accd-dc85d4e7c293',
    name: 'Shoulder Cross Chain Strap Handbag',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/15/86/1586fd0a63ed0740779716b693bb2a5d.jpg',
    cost_min: '43.46',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: 'c8f6cb1a-062a-4088-8fc5-73887459b307',
    name: 'Underestimate Me Black Cat T-Shirt',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/7d/74/7d74aca6c08b7c95469009825a61d967.png',
    cost_min: '17.39',
    categories: ['rts.womensFashion'],
  },
  {
    id: '294f43c3-cc7c-4493-8cbe-fa6d11d9e836',
    name: 'Touka Knitted Shrug Scarf - Black',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e8/0f/e80f437861125afce3620da46f8ddae3.jpg',
    cost_min: '36.40',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'de11ef88-6fbc-436b-a841-019d4523c300',
    name: 'Daoko Pleated Puff Long Sleeve Shirt - White',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/dd/49/dd49bec2325063ef17479a82163733fb.jpg',
    cost_min: '46.20',
    categories: ['rts.womensFashion'],
  },
  {
    id: '263d35c2-938c-4cdb-bee5-50e272ebe899',
    name: 'Toothpaste Tablets',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f1/61/f16176f6efb1809efb9e161391b82116.jpg',
    cost_min: '7.79',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'f776f1d3-0a36-4626-8864-ccbeab7a6f4b',
    name: 'Crystal Bubble Initial Necklace',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f5/f9/f5f92cd8ff4805951ca9aa0ae8f57598.jpg',
    cost_min: '14.25',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '845aaf27-ab01-45b6-92b8-e2a68a5d77e5',
    name: 'Android 13 8K Ultra HD Smart TV Box Wifi6 Fast Stable Transmission Media Player 4GB64GB Large Memory Netflix Youtube ATV MAXA13',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e9/02/e902877f03c2d97527b070f7faa0fb88.jpg',
    cost_min: '28.64',
    categories: [],
  },
  {
    id: '1a605399-dc85-443a-b42a-7593e270e35b',
    name: 'Copper Tongue Cleaner',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/bc/67/bc6718032fa18b39e657776175ff4938.jpg',
    cost_min: '9.00',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'c186d667-fefb-4b78-9939-f36f375544b2',
    name: 'Luxury Boots BYMANYC® HUDSON STROLL',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a2/61/a2613d8f6e3279c242af8af4febea7c8.png',
    cost_min: '150.00',
    categories: ['rts.mensFashion'],
  },
  {
    id: '8b9cbf8c-e025-4d7b-a543-12b9e45d2acc',
    name: 'Eco-Friendly Sneakers Sport BYMANYC® New York BROOKLYN BLISS',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/93/ab/93abd877eab80131129e24aaccea96de.png',
    cost_min: '165.00',
    categories: ['rts.mensFashion'],
  },
  {
    id: 'c594c310-b664-4491-bc29-7ed7a6423a7a',
    name: 'Wooden Coasters - American Walnut / Set of 4 Coasters',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/80/f0/80f0e2497a9bffd0035dc376acdf202b.jpg',
    cost_min: '17.47',
    categories: ['rts.homeGarden'],
  },
  {
    id: 'c63bae53-9010-47bb-9ed7-2dc3669b8dbc',
    name: 'Wireless Charger With Organic and Wood Material',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/30/ae/30ae4ff6b7a1e5b61dfb2ea5148d6ed4.jpg',
    cost_min: '11.16',
    categories: ['rts.cellphonesTelecommunications'],
  },
  {
    id: '26c02774-4a8d-43b0-b2bb-afe8332af0c5',
    name: 'NA9 1080P HD Wifi Mini Wireless Surveillance Camera IR Infrared Night Vision Motion Detection IP Camera Home Security Sm',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f9/14/f914c56788edf324c0c844035455ce1d.jpg',
    cost_min: '46.05',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: '734a218e-a952-4444-8bc5-30629dec46b3',
    name: 'Vintage Lattice Pickleball Paddle',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d8/7b/d87bde021ff8b4c75fb079c400b5e533.jpg',
    cost_min: '23.20',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '9646987e-0cd8-4026-b01f-17dd3b25186b',
    name: 'Nation Auspicious Clouds Pickleball Paddle',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/19/dd/19dd8ce199d4b0b9d84728c6fc1f9d89.jpg',
    cost_min: '23.20',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '0c0f5083-d281-46bf-a3e1-c0d9118446e9',
    name: 'ACOPower 30W Mono Solar Panel for 12 Volt Battery Charging',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f7/23/f723d14c01a9bc1c35b2b280d589394e.jpg',
    cost_min: '31.43',
    categories: ['rts.homeGarden'],
  },
  {
    id: '55d0dc6a-7b1f-439e-9fb8-1427d8881b17',
    name: 'Blanket Wall Rack',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/4e/5f/4e5f7b3d933b23722f6b7679df0902de.jpg',
    cost_min: '129.00',
    categories: ['rts.homeGarden'],
  },
  {
    id: '986eaa89-f78a-4253-bffb-534e033ec37b',
    name: 'Weekly Care Box (7 Pairs)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e7/4a/e74a451e8170462502ba31ea922d8c46.jpg',
    cost_min: '30.07',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '08d13fdd-bfdd-4ffe-ae9d-e37e9575a24a',
    name: 'ORIA Digital Thermometer LCD Indoor Outdoor Thermometer Temperature Wireless Temperature Sensor Thermometer for Home Office Room',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/46/d4/46d42cf978dba4b8d20f0314f233652a.jpg',
    cost_min: '23.25',
    categories: ['rts.homeGarden'],
  },
  {
    id: 'f85302b6-2c51-418b-83dd-82939237362f',
    name: 'Push Up Board; Multi-Functional Detachable Push Up Bar; Home Workout Accessories',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/72/ea/72ea0d828aa40b6051549a850e7aafd1.jpg',
    cost_min: '25.19',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '68d99667-3ae3-44be-9ff8-3b274fc3838e',
    name: 'Warmest Plush Insulated Cuff Knit Pom Women Winter Beanie Hat Warm Wool Insulated Cap Winter Beanie Hat',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/30/82/308289c2f7a0e41a18400ae3a64d8325.jpg',
    cost_min: '7.20',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'db25145c-f76a-4474-a382-56804f9e7014',
    name: 'SabertoothPro VC550 AutoPod Phone-Tablet Mount',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/69/86/69866129829db1b5cd0f6a1325d74ef8.png',
    cost_min: '23.99',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: 'dc8ad7ea-403d-42e0-a63a-d2e3c9646258',
    name: 'Sabertooth VLT350 Smart Voice Language Translator',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ec/38/ec3859edeb509c88270ac3b693aeab2f.png',
    cost_min: '38.99',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: 'a9c507bc-5d83-4acd-a90f-db2c534b571d',
    name: 'Personalized Gold Bangle - Kids Name & Date Bracelet',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a0/c3/a0c38b6bdf1922d8eda171b0c61072cd.jpg',
    cost_min: '15.00',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '3aac8bfa-3753-41a2-9e3c-7bfd20514360',
    name: 'MOIRA Complete Wear Foundation',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f6/36/f63608625c8d6b1c8be4cdbf1cbba48f.jpg',
    cost_min: '13.20',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'cc814da8-7eb5-4065-94c0-4902812aa3c7',
    name: 'iPhone | Real Aramid Fiber Case | GHOST Series',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/82/8c/828c4f8277dcdf3b5ef9d875feaac008.jpg',
    cost_min: '29.24',
    categories: ['rts.cellphonesTelecommunications'],
  },
  {
    id: 'a764574d-cce4-4bd9-bb2b-9ab359f0bd3d',
    name: "65 McMlxv Men's Khaki Chino Pant",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e3/0b/e30b0b04eee7d7c78cffcaa650777895.jpg',
    cost_min: '19.20',
    categories: ['rts.mensFashion'],
  },
  {
    id: '3ab2eaa0-24a9-4644-9de9-7764f0871a76',
    name: 'Wireless Mouse Bluetooth and 2.4GHz Dual Modes Rechargeable RGB Ergonomic Silent Click for PC iPad Laptop Cell Phone TV',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/41/5f/415f2d018eebe6246cf44a4c3744678b.jpg',
    cost_min: '3.02',
    categories: [],
  },
  {
    id: '75a7456b-e171-4a2d-9357-67e96ab6d4d8',
    name: 'Modern Feather Wooden Miniature Figurines',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/b3/93/b393c8467996d0dec2c24570ea69dfe0.jpg',
    cost_min: '16.27',
    categories: ['rts.homeGarden'],
  },
  {
    id: 'e88826af-f6af-4739-af2b-35852d1fc1c0',
    name: 'Gloriana - Women Circle Half Frame Oversize Rhinestone Fashion Round Sunglasses',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/8b/e1/8be118f5cb1dbd90d8e6e8c400ddd111.jpg',
    cost_min: '14.00',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'd7b8a0e4-3574-4ff8-b3a8-d9913b1ea6b6',
    name: 'Durable Polyester Cotton Cargo Pants for Work With Knee-Reinforcing Protection,Multi-Pockets, Comfort Fit for Constructi',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/5d/8e/5d8e240490e015cf1a16b1d9a8564d3a.jpg',
    cost_min: '35.77',
    categories: ['rts.mensFashion'],
  },
  {
    id: 'f20c9c64-d8d2-4b66-a644-2f21061b9947',
    name: 'Blushing Rosé Gemstone Diffuser',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/82/a7/82a7b6c1d47141739e547778c30d10c8.jpg',
    cost_min: '39.60',
    categories: ['rts.homeGarden'],
  },
  {
    id: 'bc58cab4-2967-4fe1-9cdf-703a8bdd6c97',
    name: '68 in 1 Electric Screwdriver Set 5 Torque Settings Precision Power Tool Magnetic Screw Driver Bits for iPhone Glasses Watch PC',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ec/f0/ecf0f654c9199c581561a92b782d84dc.jpg',
    cost_min: '33.50',
    categories: [],
  },
  {
    id: '29621a52-4ff8-4882-932a-433edab49030',
    name: 'UGREEN Finder Security SmartTrack Link Smart Tag With Apple Find My Key Bluetooth GPS Tracker for Earbud Luggage MFi Finder IOS',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/35/9d/359d205969d8d0e803bd742bfaf4e395.jpg',
    cost_min: '14.52',
    categories: [],
  },
  {
    id: 'aa101bc6-3aed-4f15-bb47-7bdbe17901fd',
    name: 'Vertical Mouse Ergonomic 2.4GHz Wireless Optical Mice 3 Adjustable DPI 800/1200/1600 6 Buttons for Laptop PC Computer Desktop',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/50/e9/50e97825aa8a4026e59196abbcdb3835.jpg',
    cost_min: '4.67',
    categories: [],
  },
  {
    id: '8db44a75-9ebc-4613-ac47-03294869994c',
    name: 'Boho Deep V-Neck Sleeveless Maxi Dress',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/86/3c/863c64b0c6d6cc9b0fdbc30593f2cb05.jpg',
    cost_min: '46.14',
    categories: ['rts.womensFashion'],
  },
  {
    id: '262c8fb0-4e4a-44eb-b01e-5654ffaaf7a1',
    name: 'Tuya Zigbee 3.0 Gateway Hub Smart Home Wireless Bridge Smart Life APP Remote Control Automation Device Works With Alexa Google',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/fe/6d/fe6d991e60deaf8af5a40513bec80293.jpg',
    cost_min: '19.05',
    categories: [],
  },
  {
    id: 'e51eb92c-ea8c-46a4-ac70-24348f6948ca',
    name: 'Multifunctional Cargo Shirt [B229]',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/bb/f1/bbf1ab3d91f7971e6e179d088408b205.png',
    cost_min: '25.05',
    categories: ['rts.mensFashion'],
  },
  {
    id: '1ff6b821-827c-4889-aa2e-d4bdde3b6596',
    name: 'Rhinestone Stone Cap',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/fd/fe/fdfe2f7fb9deb23ce986141eefec5e90.jpg',
    cost_min: '16.74',
    categories: ['rts.womensFashion'],
  },
  {
    id: '09c46beb-4116-49a1-af55-81325a71ba17',
    name: 'Bamboo Rayon Alien Hooded Turkish Towel:Little Kid',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/66/af/66af6964a5daa910d25f4cc7c2dd6936.jpg',
    cost_min: '20.99',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '746d88d7-055b-40bb-844e-2a5d8a4fefd9',
    name: 'Union - Black Silk Stone Gemstone Beaded Bracelet',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/72/eb/72eb7febb3fc83ad8e2b11ebf70e9e12.jpg',
    cost_min: '16.77',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '1c7e0c32-8226-4f5c-b458-a4b263e5be51',
    name: 'Unityth - Geometric Retro Round Vintage Fashion Aviator Sunglasses',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2f/9b/2f9b36ce283a32a98f00e8533e462d41.jpg',
    cost_min: '14.00',
    categories: ['rts.mensFashion'],
  },
  {
    id: '8f6f3f06-ec4f-4c42-8764-fd8bc02ffb48',
    name: 'Oversize Hobo Bag for Women Boho Purses and Handbags Fringe Big',
    staff_picks: ['category_pick', 'bestseller'],
    image: 'https://media.modalyst.co/cache/9a/2f/9a2f42db29a70c7b736e677fde690b7f.jpg',
    cost_min: '41.99',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: '08e81f99-fb6f-4187-9027-079de6ef6b22',
    name: '005 - Leather Wallet With Detachable Wristlet',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/72/7e/727e06fc3034a44473cf80ca1f5dfcd9.jpg',
    cost_min: '19.35',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: '924d9bae-c122-4a58-a05f-4d0c4974a74b',
    name: 'Moonlight (White Gold Peppermint) Lip Whip',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/5e/9a/5e9a69dea048d83cf88b73db421d2264.png',
    cost_min: '9.60',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '36151939-0f2b-41a0-9a86-260d1474e9be',
    name: 'Tuya Smart ZigBee Soil Moisture Sensor Temperature and Humidity Meter Thermo Hygrometer Garden Automation Irrigation Detector',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2d/0f/2d0ff58433aadc7f61558d31385a4a4f.jpg',
    cost_min: '7.64',
    categories: [],
  },
  {
    id: '847a79f0-43d6-4b14-9c48-714d065f73c2',
    name: 'Real Carbon Fiber Ring | Black | Slate Series',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/4d/95/4d959b626586a22ebee582b4c8fd8aec.jpg',
    cost_min: '12.99',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '0f0ab303-e9c4-41b3-97f8-3a74626ad875',
    name: 'Universal Cure Balm (1.4oz)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d9/c8/d9c8cddb8f68f95887fb43b8696e3a2e.jpg',
    cost_min: '17.40',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '7f8f7c10-8ca4-4503-8c03-ac1a5ffa9754',
    name: 'Irregular Design Opal Pearl Necklace',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/9c/dc/9cdc22ca5c9be3d0fa0c5b9704df75e8.jpg',
    cost_min: '48.00',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'dbb11068-851f-4295-a2b0-98c131b9d7d8',
    name: 'Freshwater Pearl Half Gold Bangle Bracelet',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/fa/4e/fa4e76f9acc113ddd90af974973354d3.jpg',
    cost_min: '52.00',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '5af780d8-f505-4d91-9ee0-d3500da1a442',
    name: 'Freshwater Pearl and Pink Zircon Necklace',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/8f/cd/8fcddae11a0e3e935e42061bd1c65120.jpg',
    cost_min: '54.40',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '46f4ba92-d025-47b8-8641-3ab795d7751e',
    name: 'Initial Edge Square Seamless Clip Charm',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/0d/24/0d246cabc81f804ea545158889d9a9c8.jpg',
    cost_min: '8.25',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '65e5d4f4-6b95-403f-981f-89c47df75998',
    name: 'Premium 100% Organic New Zealand Wool Dryer Balls',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c8/9c/c89cd885ea2fff25cfa76031b55e677d.png',
    cost_min: '14.40',
    categories: ['rts.homeGarden'],
  },
  {
    id: 'bbed9e5a-4cde-4d55-aef7-8416748bf9ff',
    name: 'DaDa Bedding Soothing SeaFoam Sky Blue Cotton Fitted Bed Sheet W/Pillow Cases (JHW604)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/05/88/05885ada682460cd10e6f892bea64f00.jpg',
    cost_min: '19.50',
    categories: ['rts.homeGarden'],
  },
  {
    id: '611d54da-4297-488b-9846-f613b8a0198d',
    name: 'BINNUNE BW06 2.4GHz Bluetooth Gaming Headset With Mic for PS5 PS4 PC Mac Playstation Wireless Gaming Headphone With Microphone',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/0c/25/0c257948959310ebe229be8d02ce2869.jpg',
    cost_min: '30.07',
    categories: [],
  },
  {
    id: 'cc0f08bd-5aba-4ad5-a5e7-f1c832452d58',
    name: "The Connoisseur's Set - Signature Glass Edition",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/7d/fd/7dfd88f4b8c919dfca6c68faaabd886d.png',
    cost_min: '38.49',
    categories: ['rts.homeGarden'],
  },
  {
    id: '11af8ec3-d669-4d6b-b2ca-c371f28272cb',
    name: 'Apple AirPods | Real Forged Carbon Fiber Case',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/86/62/866278369871b432f1a2b754b3f282d0.jpg',
    cost_min: '38.99',
    categories: ['rts.cellphonesTelecommunications'],
  },
  {
    id: '58c6af94-23a3-4435-889c-cbfc6f05a25b',
    name: 'Lip Luster Lip Gloss',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/1f/9f/1f9fdf2e26767460ac04138e2537546e.jpg',
    cost_min: '7.20',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '050d1ed8-7650-4b28-929e-b0fa84eac788',
    name: 'Baby Mobile - Hot Air Balloon',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/06/f3/06f3bb0b2a4f2a0ff249e77d5ac3e226.jpg',
    cost_min: '16.80',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'f40058c3-161c-43c6-b6d4-fb05dc31e8e1',
    name: 'Professional Gym Adjustable Jump Rope - Black',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/9f/0a/9f0a52f1f3854146542463df8953256b.jpg',
    cost_min: '5.07',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '14df3ef7-4510-46c7-a3c7-4b9da7cabbf2',
    name: 'Are You My Mother? Bamboo Muslin Newcastle Blanket',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/05/df/05dffa1d414202b7c8934187d44e6ca2.jpg',
    cost_min: '16.50',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '138fe9a8-b98c-4f54-8daf-cc2038daab78',
    name: 'LAPCOS Variety 7+1 Daily Skin Mask',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a4/20/a42036f7f2c2beecaecaff56026d5f83.jpg',
    cost_min: '13.20',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '8ff9dd7f-8fb2-444d-bf1d-4237945afd33',
    name: 'PowerGlow - Jabees PowerGlow 4-In-1 Foldable Wireless Charging Station With LED Night Light',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c8/5b/c85bd804b7d2637b0eb42fb46d0994a0.png',
    cost_min: '17.99',
    categories: ['rts.cellphonesTelecommunications'],
  },
  {
    id: 'abf89519-705b-4845-8587-9b985d78039a',
    name: 'Digital Print Hawaiian Short Sleeve Shirt',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/57/85/57851acf6f89bfb2862e541c669bb6cb.jpg',
    cost_min: '15.60',
    categories: ['rts.mensFashion'],
  },
  {
    id: 'b7334ac8-c26c-4b04-8100-4c3536531660',
    name: "Men's Sand Mix Set Socks",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/62/a1/62a12eb650c699a1911329f0962c2430.jpg',
    cost_min: '21.00',
    categories: ['rts.mensFashion'],
  },
  {
    id: '796fbb3a-ba54-468e-a3e7-d2cc45709888',
    name: 'Hdg2000 - Double Zip Around Wallet',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/36/34/3634b96dc02565fe4b45976c975a9060.jpg',
    cost_min: '9.00',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: '5f442e24-8bd6-4c79-8591-479e05f4f872',
    name: 'Genuine Leather Bag for Female Bag Shoulder Bag Large Capacity With Contrast Color Pattern Tote',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/53/82/538241a8842a2be7e17d08991edbb649.jpg',
    cost_min: '64.90',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: '99a92c83-f44c-412d-9dd8-a5434ad553ef',
    name: 'Santa Monica Leggings - Black',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f3/6e/f36ed08c8b977120746ed0aa0554fcd1.jpg',
    cost_min: '9.70',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: 'b8184058-a119-41b4-945f-6a258482474f',
    name: "The Connoisseur's Set - Palm Glass Edition",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/32/e1/32e1204424c331ac9aeaf7deabdea25f.png',
    cost_min: '38.49',
    categories: ['rts.homeGarden'],
  },
  {
    id: '695f3e0f-81b6-4199-bf56-4ea274cfee71',
    name: 'Zigbee Water Leak Detector Water Flood Sensor Alert Overflow Water Leakage Sensor for Kitchen/Bathroom',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d6/82/d682878e6c46014678410bf394a8b525.png',
    cost_min: '4.84',
    categories: [],
  },
  {
    id: '77dea216-151c-4a1c-b9b2-c680f5248b24',
    name: 'Ruffled Collar Bodysuit',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/57/32/5732921265c8ed1466ee59c09658990d.jpg',
    cost_min: '11.70',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '0e1de5f9-6b49-48ee-8861-f59995974a64',
    name: 'Grove - White Howlite & Blackwood',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/0f/1d/0f1d85ee0596e935f295540500842525.jpg',
    cost_min: '11.37',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'c0c9f1a2-3629-458e-822e-709bac90ac58',
    name: 'Lux-Lip™ Oil',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c2/52/c25238a5b3b3ee912b899747d8181512.jpg',
    cost_min: '10.80',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '615d828d-9883-40d6-a662-b97208428eb8',
    name: "Trimui Smart Pro Handheld Game Console 4.96''IPS Screen Linux System Joystick RGB Lighting Smartpro Retro Video Game Player Gift",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/fc/ec/fcecdbf46d784c2833710f66119c7898.png',
    cost_min: '102.60',
    categories: [],
  },
  {
    id: '6a996cba-aed2-460d-be90-c6067599a444',
    name: 'Pyramid Shape Tassel Wristlet Leather Bag',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c7/45/c7452abee4fafdcc00e240eaff6dfb75.jpg',
    cost_min: '26.10',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: 'e8cd2757-d9cc-4226-bd3d-889b615ba8c2',
    name: 'Portable Zoom Binoculars With FMC Lens Low Light Night Vision for Bird Watching Hunting Sports',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/43/74/437408d9259b7ce88fed5c75cb0336e5.jpg',
    cost_min: '48.70',
    categories: ['rts.cellphonesTelecommunications'],
  },
  {
    id: 'f7ce3d68-81bb-476f-870c-00747d54636f',
    name: 'Dani Glitter Bands',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/91/db/91db9e9e36258e5fa2fa3ee610293fb3.jpg',
    cost_min: '16.20',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '9e70f6d9-1cf8-4c21-a979-5a99f933c7e1',
    name: 'Flip-Flops Model 194121 Step in Style',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/cc/00/cc008b785b2707e51e691d816441b942.jpg',
    cost_min: '23.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '271ea1d9-724e-41e5-a2cb-984190c381cb',
    name: 'Passion (Neroli + Moringa) Oil (1oz)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/04/b6/04b6f660d1a7a52d3fd71668bff823ec.jpg',
    cost_min: '15.60',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'f9337801-a70a-4be5-9a7c-95213fecd623',
    name: 'Rainbow Cushion',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/6b/de/6bde72562053703544765c75996e7fef.jpg',
    cost_min: '16.20',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '90b66014-5f49-4d7d-bd4c-e4617ac072fd',
    name: "Men's High Arch Firm Support All-In-One Black Walking Shoes, Comfort & Performance Style",
    staff_picks: ['category_pick', 'bestseller'],
    image: 'https://media.modalyst.co/cache/6e/b0/6eb0a344dfdcad4cffae45226ec4d7c0.jpg',
    cost_min: '30.00',
    categories: ['rts.mensFashion'],
  },
  {
    id: '4943842f-d403-4e20-9f26-4a52c30a2032',
    name: 'Beauty of Nature Stone Wine Stopper',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/46/d1/46d1e1bc0646d613e00bd02bc49dc8aa.jpg',
    cost_min: '12.75',
    categories: ['rts.homeGarden'],
  },
  {
    id: '3d319984-d915-4f3b-a1da-7fed4af3ce62',
    name: 'Silk Wreath Hoop Earrings',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/3e/4b/3e4b61e0ca191386e36a32c5c49cd61f.jpg',
    cost_min: '36.00',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '8fbdbf41-3a30-4acf-af35-e013893a0e8e',
    name: 'Snow Boots Model 202196 Step in Style',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/38/3c/383c712e9bdb874d5e740bd678fdbb1e.jpg',
    cost_min: '20.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '5201ac4a-7895-4f04-be62-e2dab6d8cd1a',
    name: 'DUGALD | Classic Horn Rimmed Rectangle Fashion Sunglasses',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/37/50/37509dffdac0db3ab82c43628e73ecae.jpg',
    cost_min: '12.00',
    categories: ['rts.mensFashion'],
  },
  {
    id: '17ab9186-efb8-405b-abd2-45a1c8818db4',
    name: 'Sleep - Wood Roll-On Pure Essential Oils',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/6a/51/6a5168a12d4800d1bfc5de8c193db14c.jpg',
    cost_min: '13.96',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'b7358e4d-a609-4398-ae44-ba16f33ae812',
    name: 'Peter Pan Collar Dress',
    staff_picks: ['category_pick', 'bestseller'],
    image: 'https://media.modalyst.co/cache/11/94/119465f3def0feb349bfdd7678c425af.jpg',
    cost_min: '14.40',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '5bef2be7-88e8-4779-b7c0-026a79af1d9d',
    name: 'Indigo Forest Bamboo Newcastle Mini Kimono Jumpsuit',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/bd/5f/bd5f71d2e8cf613fd685b46643827ad9.jpg',
    cost_min: '12.00',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '1f461980-c886-492c-bd52-5cab6a276c97',
    name: 'Blue Bloods 2oz Beard Balm',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f2/0a/f20a30dbfebba8205507f4fcdf15a00c.jpg',
    cost_min: '13.19',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'ec4e1fab-f3ad-45a0-ad37-c5538e5998c7',
    name: 'TriVox - Triangle Bluetooth Wireless Portable Speaker',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f3/69/f369a22517c451447de915c10587ffc0.png',
    cost_min: '17.99',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: 'a14e0d98-8e8c-47a0-99b5-28e4d99ba508',
    name: 'BARRINGTON | Slim Diamond Shape Fashion Sunglasses',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/8f/fb/8ffb58fa03c1b8a52b3d0f0ce3b82ba4.jpg',
    cost_min: '11.50',
    categories: ['rts.womensFashion'],
  },
  {
    id: '3cc222d5-372a-44d7-8b16-968068abe966',
    name: 'Sport Shoes Model 198455 Step in Style',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/de/f3/def3526a154b4f4b2efc60227c660b5e.jpg',
    cost_min: '34.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '28eb007d-1e1b-489d-80af-c300a94fc608',
    name: 'Marquise Ear Climbers',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c2/62/c2628c09ae1a164557ee57e74f632aa1.jpg',
    cost_min: '22.80',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '6ebd0a14-3212-4c04-8d69-c4b9a857c9d1',
    name: 'Double Croissant Sweatshirt',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/29/3d/293de841cc8a771f300062015923574f.jpg',
    cost_min: '26.23',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '23fd1e40-51e0-4534-87cf-9a8eda897d67',
    name: 'Slippers Model 191632 Step in Style',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/10/cc/10cc2ca84753ea2978b91311c31f35f3.jpg',
    cost_min: '21.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '228b6c3b-9991-4e33-ad06-48d04b8d9c8f',
    name: 'Personalized Initial Necklace - Sterling Silver',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f3/cf/f3cfd13e132f65d43b3cbb0c3c76de9c.jpg',
    cost_min: '21.00',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'b4e40b61-a4e5-4a29-9f50-eab51ec1544e',
    name: 'Indigo Forest Bamboo Newcastle Mini Pants',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/19/d0/19d0fa9bd2049f40dc842671bef75ab4.jpg',
    cost_min: '15.00',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'f37dbf29-1572-4283-8d6e-0c5acf651d19',
    name: 'COLMI R02 Smart Ring Military Grade Titanium Steel Shell Health Monitoring IP68 & 3ATM Waterproof Multi-Sport Modes',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a8/78/a8784e4b7f20528d44a0a5f9726bad4d.jpg',
    cost_min: '14.54',
    categories: [],
  },
  {
    id: 'bc4e82c1-51d9-4cfa-bcca-3138ae91ccf5',
    name: 'The Mission Skirt',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2a/3e/2a3e0bb0858d64face189fd0fda09a16.jpg',
    cost_min: '28.80',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'd007706d-d97b-458b-98c9-044d88fdd654',
    name: 'Coat Model 77415 Venaton',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/0e/d8/0ed8d74de5ad407d69c03316bb108eff.jpg',
    cost_min: '51.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'fc7d7109-e2eb-461d-b607-9edb3d7be584',
    name: '2022 New Women Fashion Mid Waist Boyfriend Big Ripped Hole Jeans Casual High Street Denim Pants Sexy Vintage Pencil Calc',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/0b/7b/0b7b1bd2a6d50a06c2a9b4e4620ade52.jpg',
    cost_min: '36.60',
    categories: ['rts.womensFashion'],
  },
  {
    id: '3cef427b-5f0d-4bba-a31a-c24acd865c8a',
    name: 'Blouse Model 49944 Figl',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e7/ed/e7ed68b555688487a30922d999a0cb11.jpg',
    cost_min: '21.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '2fdb1a21-23c8-4db7-9525-75f1a1a0c09b',
    name: 'Turkish Cotton Blend Fringed Hobo Scarf Navy Blue/White/Red',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/78/53/78533c61ac4c958c37c2fec561388f08.jpg',
    cost_min: '5.99',
    categories: ['rts.womensFashion'],
  },
  {
    id: '9e2a090f-95e9-42de-938e-60fb683f37c2',
    name: 'Caramel Cappuccino Body Butter',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/64/f9/64f9647db34de687f371572a6bf27954.jpg',
    cost_min: '21.60',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '02c342fa-5dda-4235-909c-040227413962',
    name: 'Raw Natural Crystals | 24 Karats Pendant Necklaces',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/64/e8/64e826995a15c86a4c0c14dbe0d140d5.webp',
    cost_min: '22.19',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '4246dfc1-1718-41e0-9dc4-49436fa9d0d9',
    name: 'Eden Full Moon Ring',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/8d/ed/8ded80cf2f9fd1a7eadb519dd2aa10a2.jpg',
    cost_min: '22.80',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'd01aecb9-b539-4231-8cc9-88e900b84e57',
    name: 'Peek-A-Boo Cats and White Bamboo Muslin Newcastle Blanket',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/13/2c/132c313e582348243fba64a0dcc278a2.jpg',
    cost_min: '16.50',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '1f7cf68f-057d-4665-8dee-9080fd4252b7',
    name: 'Dahlia Floral Bamboo Newcastle Mini Pants',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/7f/88/7f883f4a86349683c1d071694827f0f7.jpg',
    cost_min: '15.00',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '0e0fc674-811b-400b-bfb8-0b9b5d32eb12',
    name: 'Santdee Irregular Tank - Gray',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/dc/e4/dce4264e53dd953b4e99d1c71c4d68f1.webp',
    cost_min: '31.50',
    categories: ['rts.womensFashion'],
  },
  {
    id: '61cc571b-1823-4491-8099-d27ff0a5aa1c',
    name: 'Baseball Footie',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f1/14/f114855e1966c9eaaff302ec8c6be63f.jpg',
    cost_min: '13.20',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '5389fe67-5813-477e-bc31-b1940ff1ae2f',
    name: 'The Aromatherapy Ritual',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/70/40/70400d12e42eedb7e95dc81f0fc6be12.jpg',
    cost_min: '33.30',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '6cab0b30-e2e1-42ea-8b80-5816946964eb',
    name: 'Blue Shadow Whales Bamboo Newcastle Mini Pants',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/bf/25/bf25d82c0b531b156c281b0a30113a27.jpg',
    cost_min: '15.00',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '4c2bf272-7f84-4e84-9fed-61871b1dd619',
    name: 'In the Wild Elephant Cotton Muslin Snap Bibs 3PK',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/b9/54/b9544b76d37601614d6a0368a0ffcbf7.jpg',
    cost_min: '6.00',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '664d2cbf-9501-4f00-96e7-81b97ec73541',
    name: '7 Inch Santoku Knife With Printed Blade-Blue',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/bd/7a/bd7adb0d0e427ad0824b392bb880fb11.jpg',
    cost_min: '13.99',
    categories: ['rts.homeGarden'],
  },
  {
    id: '442d098e-6a88-4537-9e78-71d71eee075d',
    name: 'Fearless - Sterling Silver Quote Bar Necklace',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/63/85/6385de3f54e1e3dfa583eb685b5a1e22.jpg',
    cost_min: '17.40',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '98e04f86-beb9-457b-b9b4-69c9d5db4b3a',
    name: 'Black Off Shoulder Twist Front Asymmetrical Hem Bardot Top',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2c/4e/2c4ef895b265aba4469ebd6832b1aa7e.jpg',
    cost_min: '42.52',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'dcba01b6-b316-4e4a-8e96-89e64b051894',
    name: 'Skillmatics Space Explorers - Teach Kids About Space - Write &amp; Wipe Educational Games for Children',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/df/cc/dfcc808087e03f84cdfa46af002a5046.jpg',
    cost_min: '23.99',
    categories: ['rts.toysHobbies'],
  },
  {
    id: 'f93681ef-b1a0-4928-860c-b5b510debc62',
    name: 'Pink Tie Neck Ruffle Trim Dot Pleated Fit and Flare Empire Dresses',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2f/70/2f70999e1af596c18331c691e0db0237.jpg',
    cost_min: '55.89',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'fdc0573b-84cb-4375-b0b4-50b498bbad9f',
    name: 'Iimo Limited Edition Bag',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/64/fc/64fc12148fb654d03271ddd2fd2b0d68.jpg',
    cost_min: '10.50',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '0699b19c-d3b0-49d6-907d-da36af9d1900',
    name: 'COOSPO Heart Rate Monitor Optical Fitness Outdoor Beat Sensor Bluetooth 4.0 ANT for Garmin Wahoo Bike Computer',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/8a/e5/8ae5b35517db3eb7e7fbeef0f513c448.jpg',
    cost_min: '27.47',
    categories: [],
  },
  {
    id: '3f5ce5b8-3970-4084-a2c7-db4b3d867844',
    name: 'Turkish Cotton Blend Fringed Hobo Scarf Blue Degraded',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a6/24/a6249822c4404f41c0b29e15cbebb2ee.jpg',
    cost_min: '5.99',
    categories: ['rts.womensFashion'],
  },
  {
    id: '9934db53-9248-48db-9775-8c696144e6e1',
    name: 'Choose Joy - Rose Gold Quote Bar Necklace',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/8d/1b/8d1b7d03774bcde65ba74dfafba8cf92.jpg',
    cost_min: '17.40',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '99a78819-ace3-4c9b-bf26-84ccde066dcb',
    name: 'Mye1369 - Cast Leaf Link Drop Earrings',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/21/02/210223b8777f0fb284b5a49dedeecd99.jpg',
    cost_min: '12.60',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'b4e5cb2c-bdd7-4a7d-b675-b3010ceaf3e5',
    name: 'Sakiya Pleated Long Sleeve Shirt Dress - White',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e8/52/e85208fc472d9fd1a981a3816f7a3721.jpg',
    cost_min: '42.00',
    categories: ['rts.womensFashion'],
  },
  {
    id: '7b23005d-7f4b-4ce8-98c6-ecbaeb4f45ad',
    name: 'Resistance Training & Ab Bundle',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d3/2a/d32aae40a1d8b8f0c8093e1c7562a69f.jpg',
    cost_min: '117.87',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '53143300-e4d3-4778-b1c0-ab4428b16d6f',
    name: 'Set Model 77452 Venaton',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ab/9c/ab9ce18640c1c58aecdcf4dea1b3cb01.jpg',
    cost_min: '23.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'fec788b7-507a-4036-8343-5de2995e833f',
    name: 'Flip-Flops Model 198599 Step in Style',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/7f/98/7f982bc71ef8ebf55216213c06a72e18.jpg',
    cost_min: '15.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '421b97a3-cbff-4911-b97f-d4f672414cb7',
    name: 'Nash Octagon Bangle',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/1b/42/1b42d94e6d8badfed8e72857a86c226f.jpg',
    cost_min: '30.00',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'd9731bc2-104f-4b95-ace7-dfbaddfb968d',
    name: 'Crystal Vessel Necklace | More Colors Available',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/dc/68/dc68c606085ce5f346a894173a61f883.jpg',
    cost_min: '37.20',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '8b50eee8-5d7f-417c-b1d3-9e5e8b79a7cb',
    name: 'The Feather Ring',
    staff_picks: ['category_pick', 'bestseller'],
    image: 'https://media.modalyst.co/cache/e3/7c/e37ca83b175bb403410346b14a375741.jpg',
    cost_min: '17.99',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'bc8203ac-3f54-4822-8a38-d8c5f5b0069d',
    name: 'MINI Projector Portable 3D LED Video Projectors Home Cinema Theater Game Laser Beamer Smart TV BOX 1080P 4K via HD Port A2000',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/7f/42/7f42196fcd5f3a6fe77ab2a6be0fd46b.jpg',
    cost_min: '33.74',
    categories: [],
  },
  {
    id: '9f2cd1e2-9d97-4b67-94c3-3461374e5285',
    name: 'Button Front Jean in Mid Blue',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a9/3e/a93e27810fdebb10305cff517b7fac20.jpg',
    cost_min: '47.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'ca154269-ff8f-4b09-819d-61af40a129e9',
    name: 'Kapha Body Oil | Invigorating Ayurvedic Abhyanga Oil for Oily, Congested Skin',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a3/42/a34260077d4a0d108f4813ffb101d7ec.jpg',
    cost_min: '24.00',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '1c0555ad-ba1f-4cad-b5c3-17076bbce502',
    name: 'Multi Line Rhinestone Fringe Post Earrings',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ff/9b/ff9bfc055054a38c3e808da9c471b695.jpg',
    cost_min: '5.85',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '6d20ac3e-0725-4f40-a870-6f42b4e6b803',
    name: 'Flip-Flops Model 196418 Step in Style',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/29/d7/29d74120361e83b14b9e0268c3d31da2.jpg',
    cost_min: '11.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '1c4e15ab-6810-4a0e-abc0-30c51665810d',
    name: 'Body Butter - Energy',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/12/74/1274d9b4988ffdcbf6fbec50dce06290.jpg',
    cost_min: '41.96',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'e9db46a1-e6ad-4d41-8ac6-5e51b2dabeb1',
    name: 'Snow Boots Model 203563 Step in Style',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/30/f3/30f370d45343f2c5628b36826aaa1a60.jpg',
    cost_min: '23.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '7eb35fa8-967c-40e7-8c82-f1e21cc333c3',
    name: '12 Pocket Indoor Waterproof Vertical Living Wall Planter',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/89/06/8906b79d81c7e1997abfacfaa856243c.jpg',
    cost_min: '20.97',
    categories: ['rts.homeGarden'],
  },
  {
    id: '99f79c33-d371-46e4-b36c-3269ff6c0774',
    name: 'ACOPower 240W Foldable Solar Panel With ProteusX 20A Charge Controller',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2d/d8/2dd8bb8a375ed02c5dd42199d661fcee.jpg',
    cost_min: '461.16',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: 'b033ae30-d698-48f2-ba06-be89bb8cef32',
    name: 'White Midi Dress in Tropical Leaves',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/10/a7/10a733684c601f523efaded67e8fd5c0.jpg',
    cost_min: '37.74',
    categories: ['rts.womensFashion'],
  },
  {
    id: '33282e0c-b99e-4646-afc2-557738561b76',
    name: 'Honeysuckle Solid Perfume',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/7f/02/7f02f38c017d71cfb255ec48cd712e43.png',
    cost_min: '7.20',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '438445ef-ec70-4ca6-99aa-a95386b64bb6',
    name: 'Yoga Strap Pendleton Canyonlands',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ed/a2/eda21302480e3508acbd28a9ae38c319.jpg',
    cost_min: '11.70',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '727f9a4b-e24f-408f-b060-65bdfa99e84d',
    name: 'LENOX | Women Cut Out Round Cat Eye Fashion Style Vogue Sunglasses',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a7/da/a7daf7c1cc98eaad1d330214064aa005.jpg',
    cost_min: '11.50',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'c81a13b3-af41-4092-889a-61e705feeb94',
    name: 'SERENITY Wireless Sleep Mask Headphones Bluetooth 5.0 [Free Shipping]',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f8/f2/f8f2d7e724bbff3845f554a141e22718.png',
    cost_min: '23.99',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: '058c0341-6a02-415a-b17f-9be8d94a7d0f',
    name: 'HyperFuel 100W Back-Up Power Bank for Laptops and Other Devices (20,000mAh)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f2/7d/f27d364883e67082ef984a158536fec0.png',
    cost_min: '59.99',
    categories: ['rts.cellphonesTelecommunications'],
  },
  {
    id: 'f00bf0af-37f8-4107-99cf-e09796151766',
    name: 'Sleveless Rose Petal Dress',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/39/ea/39eaec9285730d725d285f487abbd8b6.jpg',
    cost_min: '16.50',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '5ff8574e-e815-4249-b87b-638fd15eb4da',
    name: 'Dino Hooded Cotton Turkish Towel: Baby',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/5e/41/5e41784481e544fbe2d2dde873bf723c.jpg',
    cost_min: '18.00',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'cfed6e7c-15e2-4d8e-8f81-9514235b407c',
    name: 'Black Dough Bowl Fresh Squeezed Lemons Scent',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f3/3d/f33da16b5e456084c59f6291f01a5dcd.jpg',
    cost_min: '29.99',
    categories: ['rts.homeGarden'],
  },
  {
    id: '2ed540ed-a6dd-41b7-84d1-7c9906416e60',
    name: '24k Deep Moisturizer for All Skin Type',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/b6/94/b694c8451faacaaa8e02c122bfb51922.png',
    cost_min: '59.40',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '652275e2-086f-4123-b361-77344da466f0',
    name: 'Pure Plant Protein Chocolate',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/1b/84/1b841d142a9c138ebd0a7560a72d6f2a.png',
    cost_min: '33.00',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '707edd5a-8906-40b4-b1ff-5924c5d2ffe8',
    name: 'Elephant Necklace - Solid Sterling Silver Jewelry',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/95/16/9516945d71ac6ee656114d7f514ed63e.jpg',
    cost_min: '21.00',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '9038049f-7958-4217-9958-45fb25fecad3',
    name: 'Open Clover Bracelet',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f3/96/f3962c7ee7997a0e9f9930f864c8e206.jpg',
    cost_min: '47.79',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'e9521abb-d739-4429-bb96-8954a5c1ea98',
    name: 'Pure Creatine',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/65/47/654765303e583c352ff24d30d5e4974c.png',
    cost_min: '33.00',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '391e73cb-4da6-4847-9294-6ad5790148d9',
    name: '18 Karats Double Ended Natural Healing Crystals Hand Wired Necklace',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/be/10/be1049a8303f8eb7ebcb3b5eb8075e2d.webp',
    cost_min: '22.19',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'ba303b99-aa66-42a0-8dba-3ee26f0ae58b',
    name: 'Yoga Towel Pendleton Fire Legend',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a8/7b/a87bfed0f59e88445662537ec8e4e8f2.jpg',
    cost_min: '29.70',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: 'e3863626-5a4c-4a17-8c56-e77d0f206e37',
    name: 'Relaxed Multicolor Diagonal Stripe Sweater With Boat Neck in Pastel Colors',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/fc/08/fc08079b28d94453f90c79924ffb6033.jpg',
    cost_min: '44.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: '1e476011-eb15-4864-9918-956b340ab7dc',
    name: 'Marina Sailboats Bamboo Hooded Towel and Washcloth Set',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f3/31/f3319711398d4e969588f04c0eece348.jpg',
    cost_min: '26.40',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'b28a60fa-b5ac-4966-be1d-e40bcf20146f',
    name: 'Shower Steamers - Just Breathe',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f4/80/f4806f6d15c7c7359457f38593a587c1.jpg',
    cost_min: '14.30',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'e70862ec-b72c-4c3e-b3a2-8e6b22250198',
    name: 'DaDa Bedding Multi-Red Pink Boho Summer Stripes Scalloped Lightweight Coverlet Bedspread Set (DXJ101824)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/96/9c/969c4a4d326f334363b0a3e9393c6d45.jpg',
    cost_min: '35.99',
    categories: ['rts.homeGarden'],
  },
  {
    id: '2faad8a2-abdd-47e8-96a3-b819ca4d7a02',
    name: 'Body Scrub-Coffee',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/35/8d/358d078b18d79d6f3fee9d529c3a36a7.jpg',
    cost_min: '16.19',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '8c05ce80-522a-4c70-a243-979ce94e7115',
    name: 'Ashton Sports Bra - Navy Blue',
    staff_picks: ['category_pick', 'bestseller'],
    image: 'https://media.modalyst.co/cache/a4/0d/a40d722d9c090250e9071fbac216e939.jpg',
    cost_min: '9.70',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '92068471-2bae-441c-8b75-b36988a3a840',
    name: 'OMSutra Studio Yoga Mat 6mm Deluxe',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/78/65/7865f5577559493658f0aa1079ed2418.jpg',
    cost_min: '31.84',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '0dfe0ce7-28b8-4bf4-9918-7e8d55424898',
    name: 'Annalise Womens Leather Jacket',
    staff_picks: ['category_pick', 'bestseller'],
    image: 'https://media.modalyst.co/cache/08/5a/085a97b27b23522d76dec27145f9a72d.jpg',
    cost_min: '143.40',
    categories: ['rts.womensFashion'],
  },
  {
    id: '1599f1fc-fae7-4bc0-8974-a063edd4c794',
    name: 'Long Sleeve Shirt Model 198491 Figl',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c0/f6/c0f6c2dc646ac6f58d30f5ec77a93d43.jpg',
    cost_min: '41.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '013e1085-324b-4578-99a8-e3f83fb17bf6',
    name: "Goat's Milk Peppermint Body Soap",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/01/99/0199181d5527e5d1c00d93789ccd5312.png',
    cost_min: '7.79',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '6b5db5cc-8ca1-4512-bb47-7e0e1768a03b',
    name: 'Bow Sleeve Button Down Shirt',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/02/7d/027d42d0e9cf44cf3ecedf0aba04c576.jpg',
    cost_min: '13.14',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'ef255f0a-8978-42fa-b716-a46d34aefb01',
    name: 'Organic Blueberring Shorts',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c1/f3/c1f323bfe00385ed43e8568e9cf33b4e.jpg',
    cost_min: '19.65',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '8c6d94c1-eb63-4a56-b2c7-a0cf729c01e6',
    name: 'Vintage Muscle Cars and Motorcycles Bamboo Muslin Newcastle Blanket',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/26/97/269705afa8cb7b79857edd3a445fb01b.jpg',
    cost_min: '33.00',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'cfc18d19-0f07-41b8-ba39-814a96dc2371',
    name: 'High Waisted Yoga Leggings - Navy Blue',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/fd/3d/fd3da34eba9ca292446988fc8717f106.jpg',
    cost_min: '22.10',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: 'd112242b-b22e-4b79-89fb-c1dbac2b893c',
    name: '● DIABLO● APOLLO Series Forged Carbon Fiber Watch',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/9e/24/9e24531c222139a14f6c722a2683f8e4.jpg',
    cost_min: '77.34',
    categories: ['rts.mensFashion'],
  },
  {
    id: 'd1de634e-f22e-44fc-9787-f702b82926b2',
    name: 'Margot Vest',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2d/2f/2d2f796dcbb2aa5a6071b30b38f9f81b.jpg',
    cost_min: '48.00',
    categories: ['rts.womensFashion'],
  },
  {
    id: '57bd4e74-872c-421e-9014-d769b4c82d46',
    name: 'Satin Blazer in Cream',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/74/b1/74b1b3dc04ecd35bbc01ca922b7dc8e1.jpg',
    cost_min: '62.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'ff85ba84-945c-46d7-ad58-6b76479e251a',
    name: 'Set of 4, Stone and Wooden Beads Bracelet',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/1c/cb/1ccb1d5d133c5d9af7c68a51d91eaedc.jpg',
    cost_min: '15.75',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '907e39ce-883f-47cd-bb20-66db017ec5a5',
    name: "Men's Long Sleeve Gold Sweater",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a3/71/a371f7275f0987dbeb4e56be5dad888f.jpg',
    cost_min: '90.24',
    categories: ['rts.mensFashion'],
  },
  {
    id: '6b718ef1-a8a1-46ee-8a74-486253e668e9',
    name: 'Trois Seamless Sports Jacket - Black With Navy',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ed/10/ed10f89a558b613f0827a4da7803fcf3.jpg',
    cost_min: '18.50',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '1c94f5d5-d327-4131-9f19-1d424d0d1118',
    name: 'Satin v Neck Midi Dress in Blue',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/bd/19/bd19d0d98d1b97471b153eb03cd013e8.jpg',
    cost_min: '50.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: '7d76baff-f12f-4aac-b1ba-8460bed6ed52',
    name: 'Bead Flower Chain Necklace / Bracelet',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e5/29/e529a501a7da110b389cdce4f185bc63.jpg',
    cost_min: '33.00',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '3d8d5cb3-b0a5-4ec5-ad19-b8e3cc304ee4',
    name: '18 Karat Pastel Rainbow Hand Wired Band Ring',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e9/0f/e90f0a42dcb5e9686463ac6ce862e389.webp',
    cost_min: '17.39',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'cc5d0d07-315c-442d-88ba-486a2ef74fe9',
    name: 'Diamond Evening Clutch Bag for Women Wedding Golden Clutch Purse Chain Shoulder Bag Small Party Handbag With Metal Handl',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/63/a5/63a599de2f944d38704e71258eb397c7.jpg',
    cost_min: '66.60',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: 'd9face25-852a-4a86-b54d-85d7b560ab7f',
    name: 'Skirt Model 198530 Tessita',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f4/53/f4536c53c9a76d61965a103b7f354834.jpg',
    cost_min: '52.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '5df93cfa-c7cc-40aa-86f3-66d5de976bda',
    name: 'Short Sleeve Knot Tunic',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/76/04/7604496e5eb81aea3955d46275eff106.jpg',
    cost_min: '20.99',
    categories: ['rts.womensFashion'],
  },
  {
    id: '737ac684-b712-4141-b888-701743f53072',
    name: 'Macaron Earbuds - Light Green',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/07/2d/072dd7a2d4a455af60fe70524dab92f7.jpg',
    cost_min: '14.95',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: 'f135b7f7-8d94-4f68-8f84-ebe853d3cdac',
    name: 'Warmest Watch Cap Black Plush Insulated Tactical Beanie Hat Warm Wool Insulated',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/97/75/97751ec6d56b783f67008775175304d3.jpg',
    cost_min: '6.00',
    categories: ['rts.mensFashion'],
  },
  {
    id: '8e091267-d9a7-4691-b9c1-ee35ab1c4158',
    name: 'WHALE With Nylon Strap – Bluetooth IPX7 Waterproof Portable Outdoor Speaker With 30W Stereo Sound and USB Charge Out',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/8e/58/8e58ce2b318069e76b51a7b62b794270.png',
    cost_min: '41.99',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: '95254add-2645-4d3a-91ec-70df43c32d68',
    name: 'Petite Classic Chain Drop Earrings | More Colors Available',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ad/1d/ad1de4901cb1afd857c18c892ed8dc4e.jpg',
    cost_min: '26.40',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '6e4a6ca5-4451-4b49-900b-1812f6082399',
    name: '24K Baroque Freshwater Pearls Chain Choker',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/65/69/65699b09733f5a50d82e24a814ea9ba6.webp',
    cost_min: '23.99',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '4e49d203-e199-4a0d-8510-cd34a5c86269',
    name: 'Carbon Fiber POLO',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/3c/02/3c02b236c94a93d04d078be946fb7ba9.jpg',
    cost_min: '26.99',
    categories: ['rts.mensFashion'],
  },
  {
    id: 'bdd2de3a-a63f-4f54-9629-047d6becd9ac',
    name: 'Handmade Clay Smudging Bowl',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d4/fa/d4fa7ef295f854ae975b2e8b3d6e5fcd.jpg',
    cost_min: '16.24',
    categories: ['rts.homeGarden'],
  },
  {
    id: '1f333842-8167-44f0-9538-ffc458d31d35',
    name: 'Pocket Detail Jeans in Black',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c8/da/c8daccf55a25e0e0920e4c109418ec72.jpg',
    cost_min: '46.14',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'eda2bd90-01b5-40fa-9ec9-9d8a5bc9137a',
    name: 'Merida Turkish Towel / Blanket - Blue',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/57/81/5781236b2525f5cced7a87b13d643f14.jpg',
    cost_min: '27.30',
    categories: ['rts.homeGarden'],
  },
  {
    id: '21cf11c2-0bd5-466e-90fc-46f8dfb4a977',
    name: 'Real Carbon Fiber Key Holder & Organizer',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d4/75/d47582148dd9519f9931989c354d1e5f.jpg',
    cost_min: '27.29',
    categories: ['rts.cellphonesTelecommunications'],
  },
  {
    id: '0080102b-21ba-4dbb-9458-130719f4e2fb',
    name: 'The Feather Earring',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/41/ce/41ced4858c29209b852e46b6f9c6f519.jpg',
    cost_min: '19.19',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '9bf1c9b8-327d-408e-a35a-1da429ea6ac0',
    name: 'Set Model 197676 IVON',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2b/9c/2b9c7228b30e1c1b5c081d35b13ab4c8.jpg',
    cost_min: '59.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'b946ce22-332e-438c-afef-b2681697124b',
    name: '18K Rainbow Teardrop Hoop Earrings',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/19/91/19913348a12d135416a65d30eea3d2f8.webp',
    cost_min: '21.59',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '16945b79-7777-400b-b8cb-440c918d050f',
    name: 'Leopard Open Front Kimono',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/27/1a/271a33b644fad52d4cde0cd56698a7d2.jpg',
    cost_min: '13.50',
    categories: ['rts.womensFashion'],
  },
  {
    id: '45ccc01a-9da4-40b4-a4a6-bd61a20c753c',
    name: 'Open Clover Earrings',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c4/87/c487112fa4ea0bdd17f9f6d9b582eabd.jpg',
    cost_min: '44.55',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'eed83aa5-10d3-41cd-90a9-4d2d9ed725ef',
    name: 'Round Pearl Glass Teapot with Infuser - 800ml',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/4f/0b/4f0b1d75ad6964dc0a090a08b5209fd6.png',
    cost_min: '17.99',
    categories: ['rts.homeGarden'],
  },
  {
    id: '4b2c0dfe-5d1d-45c3-aef5-f818a341cf96',
    name: 'Blouse Model 141990 Stylove',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/9f/58/9f5880050dbadc792ff94d18a7d578d6.jpg',
    cost_min: '25.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'fc3edaee-44df-420f-9a0e-e89ee4523ee9',
    name: 'Shorts Model 150653 LaLupa',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/3b/b3/3bb3a9830dc78fb1154311f626d1a8a6.jpg',
    cost_min: '17.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '3cd78cb0-f77d-4d7e-8035-8377d4408a72',
    name: 'Macaron Earbuds - Light Blue',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/33/d6/33d6fca382cb800fb504eb381a904fe7.jpg',
    cost_min: '14.95',
    categories: ['rts.consumerElectronics'],
  },
  {
    id: 'dd499dc3-bbce-4781-a38c-c3c51f921ee7',
    name: 'Stripe Jumper Dress in Black',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/cb/7d/cb7dd7ed1ed6ec75119b259451fe606b.jpg',
    cost_min: '53.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: '509433d8-c2d6-4865-852a-1bcad268d68d',
    name: 'Topiom Water Rowing Machine (Dark)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/61/1f/611f29601a165e05e977c5a5e30d08dc.jpg',
    cost_min: '419.40',
    categories: ['rts.sportsEntertainment'],
  },
  {
    id: '7facc024-52ad-498e-8626-70e3daf02471',
    name: 'Pearl Huggie Drop Earrings',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/96/43/9643af4d98df8f99058fc83340e39cc5.jpg',
    cost_min: '44.40',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '547fad21-f0f0-46b4-bbc0-862f629ead5c',
    name: "Ballantine's Bottle Glass Platter",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/1d/02/1d02dd8e33f0ceb04466074555cb6b0b.png',
    cost_min: '15.34',
    categories: ['rts.homeGarden'],
  },
  {
    id: '84a40e7d-0c9e-4c13-bf25-7870fcefb788',
    name: 'La Palma Eco-Beachwear Classic Botanical Sustainable Swim Trunks',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/b8/ba/b8badc4a4a939e572cb77d9b1cf7e917.jpg',
    cost_min: '24.00',
    categories: ['rts.mensFashion'],
  },
  {
    id: 'cc55809b-38aa-4cda-8cf2-09258a34156f',
    name: 'Double Strand Necklace - Gold',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/7f/55/7f556102a9fe9a83ba0d5f8f150389eb.jpg',
    cost_min: '26.40',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '43395cb9-bfa0-41bb-885e-94f05b612cfe',
    name: 'Powder Pink Bunnies Bamboo Sleep Sack',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/45/03/45033b3754cd1309d8d6bb934142b585.jpg',
    cost_min: '20.40',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'adc0c25a-d213-4787-876f-1c5bdd3edde5',
    name: 'Mercy Cardigan',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/36/bc/36bcde48dc92f300731d12f696457c58.jpg',
    cost_min: '27.17',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'cc987db2-e5af-41cc-bdd1-4d7d7317df5f',
    name: 'Cargo Mini Skirt in Beige',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d1/6d/d16d8a9f50031deff273bfbfa5f6cfdf.jpg',
    cost_min: '41.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: '3f350b98-9fab-4cbf-829e-1f1d0cd7af49',
    name: 'Medium Hoops With Beaded Details in Gold',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f3/eb/f3eba06c72ae84991eacba8759b57666.jpg',
    cost_min: '23.94',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '6baf4b35-f7a2-45a3-822d-8764644f4c73',
    name: 'Jacket Model 161013 NM',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d7/9f/d79f072e424a555cc5b0ca511598adb9.jpg',
    cost_min: '28.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'c726beaf-af25-4637-9f99-37ac93205554',
    name: 'Sneakers Model 202228 Step in Style',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/18/3f/183f130af9fefcdaa0807c93dddeb38a.jpg',
    cost_min: '30.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '15fdf3d8-efaf-416e-9b0a-a13cee46c236',
    name: 'Cardigan Model 170543 Rue Paris',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/44/f6/44f6df3fd57149d5957c9e0ce1942f5b.jpg',
    cost_min: '19.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '64d5abde-3fef-403a-b96b-e2331b6ba8c4',
    name: 'Cardigan Model 175764 Rue Paris',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ac/d8/acd8550f1ae023c85c84aebada66376d.jpg',
    cost_min: '20.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '7e63b79d-e501-4f95-8d08-78abef5d6447',
    name: 'Humidifier Diffuser - White',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/29/60/2960004345e8a73ff26c1d8ec4a5ca1e.jpg',
    cost_min: '9.48',
    categories: ['rts.homeGarden'],
  },
  {
    id: '55c6526d-8fc4-4125-a816-7caac222d398',
    name: '#303 Botanical Facial Steam',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c0/d7/c0d71322bf305de30985a36098329d5d.jpg',
    cost_min: '16.32',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '5fcae37f-6322-4b52-bd60-f49fd87413bd',
    name: 'Suit Model 44557 Moe',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2b/aa/2baa5aaa9801dce99e52a4670cf9f559.jpg',
    cost_min: '49.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '49c64f05-300a-456a-9031-4a66fdfe2261',
    name: 'Crystal Fan Statement Hoops',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ab/ef/abef0f893960520f9a4a3a85f28f2d65.jpg',
    cost_min: '27.60',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'c1dec997-c3d9-4826-9d75-61166d8ad174',
    name: 'Organic Sailor Striped Sweater',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ac/3f/ac3f166276c137c2aa682ccc1c477518.jpg',
    cost_min: '23.41',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '3db87048-9a9b-4409-a613-b6d9a0d96a1b',
    name: 'HYPATIA 7PC COMFORTER SET',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/9f/41/9f41cf5115cbfcca31e04efec8e2dea6.jpg',
    cost_min: '77.99',
    categories: ['rts.homeGarden'],
  },
  {
    id: '7d7043ff-fddf-4199-b76f-7828aba756bd',
    name: 'Pink Rabbit Richie Rattle by Happy Horse',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/b5/73/b5735515e042cf8d6f6f950787a53440.jpg',
    cost_min: '9.00',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '7b62b4ec-51e3-43ee-8cc4-a6fbb444c5eb',
    name: 'Dare Me',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/22/5a/225a93f2b0d8fd5c268563124b39e682.jpg',
    cost_min: '9.00',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '949cba8c-8878-419f-a398-c3c9880bc44d',
    name: 'Natural Rose Quartz Crystal &amp; Freshwater Pearls Choker',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/83/94/83943bb0c6f4f6bee665f91db1120123.webp',
    cost_min: '26.99',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'a18055d4-578c-4043-a0ca-da08d3b22eb8',
    name: 'Kids Vibrant Sky Argyle Socks',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/20/11/20116ff115591ae7a6e3983028990ded.jpg',
    cost_min: '4.80',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'ac235fb1-0b2a-4070-a618-773aecf293bb',
    name: 'Andana Striped Tablecloth Set - Magenta',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/3b/7d/3b7d697622563a5bf62ea6d21b327562.jpg',
    cost_min: '66.00',
    categories: ['rts.homeGarden'],
  },
  {
    id: '17591556-0893-4c8a-88b6-12f5c797e328',
    name: 'MBO-8746 Sand',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/8d/98/8d98d714d5b9c2d33f13e0a248f5eb17.jpg',
    cost_min: '20.24',
    categories: ['rts.mensFashion'],
  },
  {
    id: 'dfed20fd-e60b-4fe5-8258-e14eb19ef5b1',
    name: 'Kate - Blue Vegan Basket Weave Bag',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/76/e1/76e174cf3c259b381096b57fd47e7b96.jpg',
    cost_min: '100.80',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: 'be78cb5f-9ed4-4132-8e92-79cf3be89402',
    name: 'Pave v Charm Necklace',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/3e/58/3e583e6b845037d28e05b7c294535517.jpg',
    cost_min: '32.40',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'b4bd35e2-c960-4d22-b1bc-4fa6f508a639',
    name: 'Joggers With Elastic Waist Band in Gray',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/3e/6c/3e6c469f3b19701e1c5dab59793a8b99.jpg',
    cost_min: '35.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: '6db589a8-f79a-493a-b5b8-adb18d01e0cf',
    name: 'Brenda Sequin Dress',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/8e/24/8e245f4cf8bb9b2ebdddacc587b3b703.jpg',
    cost_min: '41.40',
    categories: ['rts.womensFashion'],
  },
  {
    id: '7440b7fb-3f3f-4fad-9257-82b1156c15c9',
    name: 'Cherry Vibes Cardigan',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/b2/7f/b27fbb77ec9abd8937c9043969ecdd63.jpg',
    cost_min: '32.81',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '8b3c1e16-53ff-4ef3-9c64-e2233ac8b94a',
    name: 'Cozy Turtleneck Sleeveless Sweater in Burgundy',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f9/ca/f9ca660db2979897761e84284e5ddce8.jpg',
    cost_min: '35.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'cf2179db-a9ee-409b-b8b8-15476bdbab2f',
    name: 'Beige Sequin Playsuit Romper',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/10/ae/10aea624d36ba3f1ca93deb22639c388.jpg',
    cost_min: '27.00',
    categories: ['rts.womensFashion'],
  },
  {
    id: '914bbcb6-0a2d-43b0-b50b-7fc62eca7550',
    name: 'The Whiskey Decanter Gift Set',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/25/d3/25d3e9e9f0070dc4df9af3ac3dca9664.png',
    cost_min: '69.99',
    categories: ['rts.homeGarden'],
  },
  {
    id: '6121c4e7-6448-48bb-95f6-8147fa567629',
    name: 'Coated Pants in Orange',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ed/a9/eda99534f0f5a616146a65ea6d2942a3.jpg',
    cost_min: '40.14',
    categories: ['rts.womensFashion'],
  },
  {
    id: '5ab9f11e-5b52-4297-b740-4c97c810c160',
    name: 'Alanda Bentley Jumpsuit - Black',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/4d/05/4d0548bf60ef447932390916d8476243.jpg',
    cost_min: '22.10',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'ccd94d9f-726e-4f8e-9db2-c65e4f928281',
    name: "ZIMEGO Men's 3/4 Sleeve Black & White Baseball Henley – Casual Athletic Button Crewneck Shirts",
    staff_picks: ['category_pick', 'bestseller'],
    image: 'https://media.modalyst.co/cache/cc/f2/ccf2337d74b11006ec8aee3ed5101287.jpg',
    cost_min: '15.00',
    categories: ['rts.mensFashion'],
  },
  {
    id: 'ef4a254e-3a34-4243-bb7c-0f83e452d674',
    name: 'Floral Print Maxi Dress With v Neck in Pink',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/c5/84/c584f4542151c0d704e7c6f7be6e5743.jpg',
    cost_min: '47.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: '590e0068-e388-46e2-b51a-c2a1fab66eae',
    name: 'Dog Herald No. 2 Plush Animal by Happy Horse',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e1/77/e177bd7b86fed45ab3d5fd31f6577070.jpg',
    cost_min: '19.20',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '562be5a6-4252-4f51-8535-adfd5bf1e6d5',
    name: 'Hamsa Hand Bracelet',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/dd/da/ddda109233bfe28c254903be9784a2bb.jpg',
    cost_min: '47.79',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'e7176dd8-7e06-4a35-873f-ee3fd5b00bf3',
    name: 'Satin Cami Strap Midi Slip Dress in Green',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/4e/12/4e1291b978b242a05f46df8451323525.jpg',
    cost_min: '53.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: '3a2aeb50-e7cd-40b8-b359-1b786813bd9c',
    name: 'Raw Hem Skinny Jeans in Brown',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f9/da/f9dac2c6514de1cdadcc3287e27a8e48.jpg',
    cost_min: '44.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: '912681b4-8d20-44a5-8a79-f0c2d52b7cb9',
    name: 'Mr Roboto Heather Navy',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/9a/db/9adb6dbbd4b89e0115aeb881cb241741.jpg',
    cost_min: '6.00',
    categories: ['rts.mensFashion'],
  },
  {
    id: '99c28e6d-e9c3-4074-90df-bc05ac63d993',
    name: 'Skirt Model 196748 Badu',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d7/5b/d75bd33029a1f372e82669075073e784.jpg',
    cost_min: '19.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '8f5f68ac-792b-4a1e-9162-15df021dc7b8',
    name: 'Lava Stone Chakra Blue Bracelet',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/9e/67/9e6725d9a31ad04d126c6d187d1569df.jpg',
    cost_min: '13.96',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'ff80574e-72b9-4f93-a8eb-50f70874525b',
    name: 'Inverness - Walnut & Black Leather',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/fe/e8/fee8681753894fcad31b5e255e690c51.jpg',
    cost_min: '26.97',
    categories: ['rts.mensFashion'],
  },
  {
    id: '78bd6964-fbc2-4ca7-8dd6-d946abc72750',
    name: 'Tessa Double Drop Earrings | More Colors Available',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/0c/6c/0c6cfa5031f3e61d24de918d1c323a63.jpg',
    cost_min: '26.40',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'e737aebe-c15f-47ef-a011-7faff8db5803',
    name: 'Jumper Model 199237 Badu',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ac/72/ac726039dc86c33987c17cb66dbb87b1.jpg',
    cost_min: '22.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '0ed5ba6f-9735-47a8-bbf7-8b714508ff9e',
    name: 'Hydrate Blend Tea',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/bd/9f/bd9f2eb256a58e53cb79d94379f0f21b.jpg',
    cost_min: '19.80',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'acbee3af-72a0-439b-95d6-6e737c38d2c3',
    name: 'Kiwi Small Leather Backpack',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a0/d1/a0d13cc2559871d8aa9450151afc5bfa.jpg',
    cost_min: '57.20',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: '34ac0092-d47b-4337-9445-8e5de8cd3eb3',
    name: 'Classic Chain Bracelet',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/94/58/9458bd27d4f95908176456acc55c0cb1.jpg',
    cost_min: '33.00',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: 'a897ce02-79ce-41c1-bacc-c06b716120e4',
    name: 'Leopard Printed Tote Bag',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/fa/9f/fa9f0c69c4a5527c253a5f1886de0de0.jpg',
    cost_min: '9.90',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: 'd6c464cc-0b8c-4670-8b26-f2b281fa09ea',
    name: '1929 Indian Motorcycle Army',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/59/00/5900d8ee1819798c93692a81d610e12e.jpg',
    cost_min: '12.00',
    categories: ['rts.mensFashion'],
  },
  {
    id: 'c513f898-8109-4961-8c0d-302b363442ca',
    name: 'Naomi - Yellow Vegan Leather Tote Bag',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ea/d3/ead3a3ba8c936a18f54c77f3662fd55b.jpg',
    cost_min: '105.00',
    categories: ['rts.bagsLuggage'],
  },
  {
    id: 'adbb13fb-74f3-453b-b395-574e0264e35c',
    name: 'Kendra White Shirt Dress',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/99/98/9998ab63dd565e423188730f7505d88a.jpg',
    cost_min: '34.80',
    categories: ['rts.womensFashion'],
  },
  {
    id: '6d684e29-0a7a-42f1-b7b4-1510558936fc',
    name: 'Visor Cap in Blue',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e1/de/e1deec727e66bb89dd14c38fe70c1c9e.jpg',
    cost_min: '44.94',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'a194635c-8cbb-45c7-8eb9-5c3807d4d2ec',
    name: 'MEVADEN 1.85 Outdoor Military Smart Watch Men Bluetooth Call Smartwatch for Android IOS IP68 Waterproof Sports Fitness Watches',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/0b/6d/0b6d1b319ff789d6305daed07bad0687.jpg',
    cost_min: '28.91',
    categories: [],
  },
  {
    id: '44f29b44-80ca-4149-bd2c-385a3790163c',
    name: 'Flutter Sleeve Denim Dress',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/27/83/2783a4dc6c3bdadd140af6473aae8cd0.jpg',
    cost_min: '20.82',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'fa2136f0-03ac-4455-9121-286d03018ed4',
    name: 'Set Model 193631 Badu',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/2e/16/2e169ed416a48009ae95b39890b819cf.jpg',
    cost_min: '19.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '29b78c4f-15ad-410e-855a-f2e3448138aa',
    name: 'Jacket Model 197062 Och Bella',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/03/b1/03b14313230be04224d2c42add44c79b.jpg',
    cost_min: '32.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '21a39150-ca98-4b2f-aa35-b5aceb8df6ea',
    name: 'Daydress Model 183160 Tessita',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/eb/ec/ebec0a5f96bc98bf3858e4e9929fc017.jpg',
    cost_min: '40.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '48948527-6309-4d18-bdba-38804c713aa9',
    name: 'Lavender Pure Essential Oil - 15ml',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/d8/b8/d8b8e01194251a1a04900b6e147fa1b6.jpg',
    cost_min: '12.60',
    categories: ['rts.beautyHealth'],
  },
  {
    id: 'a93b50b2-a17e-4c6b-bd10-4c4679fae5e7',
    name: '"Be a Pineapple Stand Tall" Cosmetic Bag',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/25/9f/259f26fc4228cf18fe640bf4a91a96ba.jpg',
    cost_min: '6.75',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '08996540-195f-43b8-a44f-5285d3d97fe7',
    name: "ZIMEGO Men's Stretch Flex Slim Color Washed Vintage Rugged Fashion Button Shirts",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/3b/b6/3bb611c3271dbb26525977328dee7c99.jpg',
    cost_min: '21.50',
    categories: ['rts.mensFashion'],
  },
  {
    id: '9dcd340f-10a4-4950-b186-d3cd4a8b3390',
    name: 'Organic Heart Garden Pants',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ec/ad/ecadedc517af0088c67bed1b21e108a4.jpg',
    cost_min: '18.00',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '5b97741a-810f-4592-8f9a-9e76aad0ea1d',
    name: 'Onyx Coasters - Set of 4',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/16/2d/162d4de2073a6a5de13cc6978cae17bd.jpg',
    cost_min: '18.00',
    categories: ['rts.homeGarden'],
  },
  {
    id: '497c5b54-0813-402d-b6a6-6d765f3d002b',
    name: 'Enosi - Original',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/1a/b8/1ab88f690799fd919b91bb9f6e1e171b.jpg',
    cost_min: '38.55',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '5b21ac9d-ebdd-48bb-b462-d58a52325896',
    name: 'Wall Stickers - Mini Watercolor Rainbows',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/50/cb/50cb1b260f5b8f3a08792532ef5901c6.jpg',
    cost_min: '23.40',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '7a421c73-015d-478e-9169-f2291eafa63e',
    name: 'Wall Sticker - Watercolor Robot',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/ea/10/ea107bb31cb931db2c88e4a1d437eada.jpg',
    cost_min: '16.20',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '65ecd400-564f-4ae7-9bb0-8451f7972a19',
    name: 'Wall Stickers - Wooden Toys',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/9e/26/9e26115d2e8e4b0bd65dd3286fe033e5.jpg',
    cost_min: '23.40',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'bb4a7350-adc4-4fc5-a728-dd12b5d02957',
    name: 'Handmade Crystal Intention Candles',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/9d/b8/9db8c20b05d865fddb3835f97c74e8d6.jpg',
    cost_min: '10.80',
    categories: ['rts.homeGarden'],
  },
  {
    id: '6f92e7e1-7f41-47d7-8ff7-a0c819c28e47',
    name: 'Puffer Shorts',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/9c/9c/9c9c1210b413bee7a21aa5025225cccb.jpg',
    cost_min: '25.19',
    categories: ['rts.womensFashion'],
  },
  {
    id: '85e948b8-6a59-4e6d-b525-279d626d8fb6',
    name: 'Mama Stuff Statement Tote Bag for Mums (Hospital Bag - Baby Shower Gift)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/91/1f/911f56c4d1916c9ab99a708c1efeebe3.jpg',
    cost_min: '13.48',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '90e7c1ec-184c-452a-88a6-50c56776657a',
    name: 'Black High Slit Gown',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f4/d1/f4d1fa3d04928b0586fab995636a4105.jpg',
    cost_min: '58.80',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'd683e15e-8e70-4397-828e-f2234240f497',
    name: 'Kylemore - Bamboo',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f4/7c/f47c40f29ae45e29b9b1de6d85e30623.jpg',
    cost_min: '23.37',
    categories: ['rts.mensFashion'],
  },
  {
    id: '51a598f2-c82f-4dac-8212-e4d7f97ef80b',
    name: 'Beads Stack Bracelet',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/7e/22/7e225c360d82ced5fc02502bf85ae5f6.jpg',
    cost_min: '7.20',
    categories: ['rts.jewelryAccessories'],
  },
  {
    id: '98b935ac-e586-43d2-a0ba-93130370e5bc',
    name: 'Coat Model 184518 Fasardi',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/5b/84/5b84ede4a6a947a1ecb2fc4a9283ce57.jpg',
    cost_min: '31.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '3de3631e-029b-4171-82d5-487fa50b8033',
    name: 'Turtleneck Model 199611 Badu',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/2e/6c/2e6c69dbc4fd2e3572ce1dcbf316abb5.jpg',
    cost_min: '19.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: '89b7af72-09f8-47bd-bb35-0d557be9a848',
    name: 'Cherry Bottom Sweatpants',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/05/44/05445051728aabcce3338a9659fdb4cb.jpg',
    cost_min: '18.71',
    categories: ['rts.kidsBabies'],
  },
  {
    id: 'e4b1249d-3c25-4eda-8d87-d1b9197d878a',
    name: 'Buskin Model 209886 Step in Style',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/1f/5f/1f5fe9fdf94a645fb45f66093c24e6a1.jpg',
    cost_min: '20.90',
    categories: ['rts.womensFashion'],
  },
  {
    id: 'fd6c112e-c05d-47fd-8eee-dba4d50dbab0',
    name: 'Eyewood | Engraved Wooden Sunglasses - Mandala',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/b3/3f/b33f27a919db03c38d855fc3ad977643.jpg',
    cost_min: '15.60',
    categories: ['rts.mensFashion'],
  },
  {
    id: '3cd66c44-67d6-44c4-9555-d5a502b1ba43',
    name: 'Organic Heart Garden Ruffle Dress',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e0/a2/e0a2eea407345fcfcb6a5bb7092190db.jpg',
    cost_min: '30.93',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '9603d171-c683-4278-aa96-8ec04031382d',
    name: 'Egyptian Cat Pillow Cases',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/f6/37/f6377ca7230d42448772957ff6138698.jpg',
    cost_min: '9.00',
    categories: ['rts.homeGarden'],
  },
  {
    id: 'b61dcf4d-98d2-40a1-8879-12cdf73dc029',
    name: '●SPORT● Real Carbon Fiber Sunglasses (Polarized Lens | Acetate Frames)',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/1e/9c/1e9cf16a8f2e2f69c3269baeea672b6e.jpg',
    cost_min: '48.74',
    categories: ['rts.mensFashion'],
  },
  {
    id: '56873564-4d10-40cc-8f01-48d93fe6a90b',
    name: "Men's Style Lace Up Leather Casual Shoes (Black)",
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/a1/2d/a12de95c2803e511cae0f46456612173.png',
    cost_min: '62.40',
    categories: ['rts.mensFashion'],
  },
  {
    id: '60dcc9b2-1b74-4f15-9b4e-3c132f7f1be6',
    name: 'Active Daily Gel Cleanser',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/01/8c/018cf64b117381011e63e6583ca1288b.png',
    cost_min: '23.40',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '50796953-b87e-44d3-8d8e-b7e9591b2182',
    name: 'Medium BB Cream',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e3/52/e352e93fb3f0a05c27027952aad17bd7.jpg',
    cost_min: '28.80',
    categories: ['rts.beautyHealth'],
  },
  {
    id: '2f6422c7-14bd-415f-9f5e-bd6c4715b402',
    name: 'Monkey the Curtain Holder',
    staff_picks: ['bestseller', 'category_pick'],
    image: 'https://media.modalyst.co/cache/0d/b5/0db57b11f02b705dbdb7de844147eaee.jpg',
    cost_min: '12.00',
    categories: ['rts.kidsBabies'],
  },
  {
    id: '97f4ae17-37c4-4fa1-808d-41da3d2e76ab',
    name: 'The Cooper | Oxblood Leather',
    staff_picks: ['category_pick'],
    image: 'https://media.modalyst.co/cache/e5/29/e529e9b90172bf817a0c109451566b8a.jpg',
    cost_min: '59.40',
    categories: ['rts.mensFashion'],
  },
];

export const PRODUCTS_BY_CATEGORY = {
  'rts.beautyHealth': [
    {
      id: '4af26b3c-5b2d-4c36-a782-1541715633ff',
      name: 'BeardGuru AppleBlossom Beard Oil',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/22/71/22714f6fbde831c38be4df8fc108bc53.jpg',
      cost_min: '13.79',
    },
    {
      id: '5ab6aad8-e7dc-40f7-a99f-b2cd2db9e691',
      name: 'Aftershave Serum Bundle (5-Pack)',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/75/5a/755ac8daf3f7c261fdd549fe9b282039.jpg',
      cost_min: '41.39',
    },
    {
      id: '58e0a5b7-71f2-4908-9e4e-cc5bcd964396',
      name: 'Oatmeal & Goat Milk Handmade Soap',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c3/14/c314843234dae3c8c11baa044c2eea86.png',
      cost_min: '2.70',
    },
    {
      id: '882e36f7-fba7-40ee-8d84-ee77dea101b4',
      name: 'Mineral (Baking Soda-Free) Deodorant',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/44/e3/44e397a90383cbde9e4a2b921d085e18.jpg',
      cost_min: '5.99',
    },
    {
      id: '1894e343-d747-4bbb-9137-0097029a9db7',
      name: 'Grapefruit Splash- Grapefruit Scented Handmade Soap',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/3e/7c/3e7c70dccb4c2176fb393aedb3d126cc.png',
      cost_min: '2.70',
    },
    {
      id: 'e7f59821-341d-416e-9cb9-0ef9c5882020',
      name: 'Cheek Flush (Talc-Free)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/7e/a7/7ea737f372a54f8fa91509e1f14b9c54.jpg',
      cost_min: '7.20',
    },
    {
      id: 'a87ef190-04c8-441f-81a5-72db992782ee',
      name: 'Lustrao Hair Regrowth Oil',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d9/75/d97589d65dbaa2c26fe8eed09a68b8ef.png',
      cost_min: '16.19',
    },
    {
      id: '3afce4e2-58a8-4257-9213-93eeca4837eb',
      name: 'Vitamin C Repairing Oil',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/8b/a3/8ba372e4e69df9d0ec2c2b625ce2b459.png',
      cost_min: '11.99',
    },
    {
      id: '5b0f5b73-356b-4c20-bd40-aa6c6309286c',
      name: 'Face Mask',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c7/19/c719fa980a650bbc3427f2523626cff2.png',
      cost_min: '11.99',
    },
    {
      id: '373157b3-b693-4c6c-a4de-65507f408992',
      name: 'Advanced Skin Regimen Kit (5-Piece Set)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/91/6a/916a07ecff5156b149363b1dc0782ca1.jpg',
      cost_min: '35.39',
    },
    {
      id: '4709560d-c7c7-4817-9b3a-df444e5b57c9',
      name: 'Salt Scrub (Multiple Sizes)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c9/b9/c9b970858a7899ceab5946303fd8fb55.jpg',
      cost_min: '10.19',
    },
    {
      id: '07ebb848-f56b-4a21-b1f0-0cacd16ef325',
      name: 'Essentials Skin Regimen Kit (4-Piece Set)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/45/8d/458d2342f5794d1dca90021667a6369c.png',
      cost_min: '23.99',
    },
    {
      id: '5dfd173b-a36e-41dc-8adc-21156f043dfe',
      name: 'Hair Serum',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ad/97/ad97d6bc0a7078ccbe3527dd7c86a24a.png',
      cost_min: '16.79',
    },
    {
      id: '3c2776d6-cdae-4ef1-8125-0aaeeb0d6175',
      name: 'Shave Brush',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/1c/01/1c0120f047bebeb5fcc08ddecac05a8d.jpg',
      cost_min: '6.59',
    },
    {
      id: '88b4441e-04e4-4f4a-a3cd-e808e66dfcf3',
      name: 'Natural Loofah Pad 2-Pack',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/8e/45/8e45b5ab3ecdea1f23b56a152e7dcb7d.png',
      cost_min: '5.99',
    },
    {
      id: 'dcc37698-e1bb-49e2-bcbc-4c8e55d06a05',
      name: 'Eucalyptus Radiata  Pure Essential OIl-15ml',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/a1/f7/a1f74232576c950f04165ef8ef7cff14.jpg',
      cost_min: '8.40',
    },
    {
      id: 'd80b2f1a-86de-4fd4-baed-bd8cb501a03c',
      name: 'Rebel Beard Oil',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4b/05/4b058ef34fb46f97f01e500613644674.jpg',
      cost_min: '13.79',
    },
    {
      id: '9d955236-a19c-4cfd-ac08-a074c43b5896',
      name: 'BeardGuru AppleBlossom Beard Balm',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/94/1f/941f92de0dc4cfb0699c978b4931e3a3.jpg',
      cost_min: '14.39',
    },
    {
      id: '47c563f1-1649-43e4-8209-388a4e878f4b',
      name: 'Turmeric & Honey Handmade Soap',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/06/f2/06f2eb92ed5a233e687387681c7c3598.png',
      cost_min: '2.70',
    },
    {
      id: 'd44c6cc7-ae76-478b-8f37-27a57903563d',
      name: 'Bamboo Charcoal Detox Handmade Soap Bar',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/94/b3/94b3329c1f9e960e9d98a9a7a80c5cb6.png',
      cost_min: '2.70',
    },
  ],
  'rts.mensFashion': [
    {
      id: 'd5542416-c060-48ec-a7f2-2c6e412840a0',
      name: 'Linen Mens Shorts Newest Summer Casual Shorts Men Cotton Fashion Men Short Bermuda Beach Short Plus Size 4XL Joggers Male Hot',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/d5/83/d583a692876e12efa964fb951d446f30.jpg',
      cost_min: '15.69',
    },
    {
      id: '09f49cca-244f-4d4d-b880-26292aedab4c',
      name: 'The Endless Summer 1966 Surf Documentary T-Shirt',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/53/45/534592c59fe11ec07698865f27f5abf4.png',
      cost_min: '13.17',
    },
    {
      id: '90b66014-5f49-4d7d-bd4c-e4617ac072fd',
      name: "Men's High Arch Firm Support All-In-One Black Walking Shoes, Comfort & Performance Style",
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/6e/b0/6eb0a344dfdcad4cffae45226ec4d7c0.jpg',
      cost_min: '30.00',
    },
    {
      id: 'ccd94d9f-726e-4f8e-9db2-c65e4f928281',
      name: "ZIMEGO Men's 3/4 Sleeve Black & White Baseball Henley – Casual Athletic Button Crewneck Shirts",
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/cc/f2/ccf2337d74b11006ec8aee3ed5101287.jpg',
      cost_min: '15.00',
    },
    {
      id: 'ff80574e-72b9-4f93-a8eb-50f70874525b',
      name: 'Inverness - Walnut & Black Leather',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/fe/e8/fee8681753894fcad31b5e255e690c51.jpg',
      cost_min: '26.97',
    },
    {
      id: '03e35462-f6f3-4424-9774-ec87b38efe1f',
      name: 'Pablo Picasso Dove of Peace 1949 Artwork T-Shirt',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/44/62/4462e475e8e6507bd7d6a283d317cef5.png',
      cost_min: '13.17',
    },
    {
      id: 'ed380a08-3c99-4c8a-9889-bab6ca04bee9',
      name: "Andy Warhol's Banana, 1967 Pop Art T-Shirt",
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4f/bf/4fbf4ff745af583a481ec3bb6b134555.png',
      cost_min: '13.17',
    },
    {
      id: '9d9c434d-5517-4a7e-b1ac-0cd080c654b8',
      name: 'MTR-8748 Navy',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/64/6f/646fc0a0cf007dbbc6c21049f703fbb3.jpg',
      cost_min: '18.62',
    },
    {
      id: '4b0e72ab-22e3-4aed-9db5-32f6842b5686',
      name: 'Banksy Anarchist Punk and His Mother Artwork T-Shirt',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/2d/78/2d78f602d3bf42cf432bbf6f0365fdb5.png',
      cost_min: '13.17',
    },
    {
      id: '787a7508-de25-49ea-b5c7-079ccbb1c973',
      name: "Save Ferris From Ferris Bueller's Day Off T-Shirt",
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d9/c6/d9c6875248c9535c3c4fe240d5df6fec.png',
      cost_min: '13.17',
    },
    {
      id: '61122b8b-a0af-4a5b-aeb1-854effc54f7d',
      name: 'Amity Island Surf Shop, Jaws T-Shirt',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/76/cb/76cb0f1f7fdaaaa8a68d9b7c8d982bd0.png',
      cost_min: '13.17',
    },
    {
      id: 'f9f08587-5ce6-4bd8-b864-06c146fa5316',
      name: 'Find Your Coast® Heritage Sunset Explorer Hoodie',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/1c/7f/1c7ffad5c2d10a28880a1b1fad0e618d.png',
      cost_min: '47.40',
    },
    {
      id: '89d862ee-8fda-4857-a0cb-affb8d5cd383',
      name: '100% Cotton Short Sleeve Fucus Printed Tshirt',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/2e/cc/2eccc8d6dce42a1da1aeaa2b3d07a2aa.jpg',
      cost_min: '20.39',
    },
    {
      id: '8531a862-53ba-4909-a31b-21c82815e9f8',
      name: 'HATLANDER Camouflage Snapback Polyester Cap Blank Flat Camo Baseball Cap With No Embroidery Mens Cap and Hat for Men And',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ec/1e/ec1ec3a2403fdd3ffe27ad9149fbb02a.jpg',
      cost_min: '31.56',
    },
    {
      id: 'c186d667-fefb-4b78-9939-f36f375544b2',
      name: 'Luxury Boots BYMANYC® HUDSON STROLL',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/a2/61/a2613d8f6e3279c242af8af4febea7c8.png',
      cost_min: '150.00',
    },
    {
      id: '8b9cbf8c-e025-4d7b-a543-12b9e45d2acc',
      name: 'Eco-Friendly Sneakers Sport BYMANYC® New York BROOKLYN BLISS',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/93/ab/93abd877eab80131129e24aaccea96de.png',
      cost_min: '165.00',
    },
    {
      id: 'a764574d-cce4-4bd9-bb2b-9ab359f0bd3d',
      name: "65 McMlxv Men's Khaki Chino Pant",
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/e3/0b/e30b0b04eee7d7c78cffcaa650777895.jpg',
      cost_min: '19.20',
    },
    {
      id: 'd7b8a0e4-3574-4ff8-b3a8-d9913b1ea6b6',
      name: 'Durable Polyester Cotton Cargo Pants for Work With Knee-Reinforcing Protection,Multi-Pockets, Comfort Fit for Constructi',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/5d/8e/5d8e240490e015cf1a16b1d9a8564d3a.jpg',
      cost_min: '35.77',
    },
    {
      id: 'e51eb92c-ea8c-46a4-ac70-24348f6948ca',
      name: 'Multifunctional Cargo Shirt [B229]',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/bb/f1/bbf1ab3d91f7971e6e179d088408b205.png',
      cost_min: '25.05',
    },
    {
      id: '1c7e0c32-8226-4f5c-b458-a4b263e5be51',
      name: 'Unityth - Geometric Retro Round Vintage Fashion Aviator Sunglasses',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/2f/9b/2f9b36ce283a32a98f00e8533e462d41.jpg',
      cost_min: '14.00',
    },
  ],
  'rts.jewelryAccessories': [
    {
      id: '7905e13b-804b-4b92-baf6-df87fd285af6',
      name: 'Silver Mountain Necklace',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/de/71/de71c5bc14b8c97d348d0d5871fc315b.jpg',
      cost_min: '23.40',
    },
    {
      id: '8b50eee8-5d7f-417c-b1d3-9e5e8b79a7cb',
      name: 'The Feather Ring',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/e3/7c/e37ca83b175bb403410346b14a375741.jpg',
      cost_min: '17.99',
    },
    {
      id: 'cd2d7cd9-a633-4006-9509-25ecb3037e55',
      name: 'Mye1038 - Fan Shape Drop Hoop Earrings',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d6/41/d641f81c91e1221ec79afcf8ac685047.jpg',
      cost_min: '4.95',
    },
    {
      id: '721b545d-ba3a-49c3-801f-20fed1fc49c1',
      name: 'Geometric Open Circle Ring',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/49/49/49499b0d0696860a0e2fa0c4302df474.jpg',
      cost_min: '36.00',
    },
    {
      id: 'b1907ac1-d1b7-4d5d-8f52-f54b1014f71b',
      name: 'Twist Cross Floral Elastic Knotted Headband',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d4/46/d4469c82c00462ff092078a1b0450ed7.jpg',
      cost_min: '13.02',
    },
    {
      id: 'db56d4d3-5f9b-4804-8470-2cb0c284a25b',
      name: 'Mama Bear and Cub Necklace',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/17/3d/173dd3d88a369cbb9d653c54218cd42c.jpg',
      cost_min: '23.40',
    },
    {
      id: 'f776f1d3-0a36-4626-8864-ccbeab7a6f4b',
      name: 'Crystal Bubble Initial Necklace',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f5/f9/f5f92cd8ff4805951ca9aa0ae8f57598.jpg',
      cost_min: '14.25',
    },
    {
      id: 'a9c507bc-5d83-4acd-a90f-db2c534b571d',
      name: 'Personalized Gold Bangle - Kids Name & Date Bracelet',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/a0/c3/a0c38b6bdf1922d8eda171b0c61072cd.jpg',
      cost_min: '15.00',
    },
    {
      id: '746d88d7-055b-40bb-844e-2a5d8a4fefd9',
      name: 'Union - Black Silk Stone Gemstone Beaded Bracelet',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/72/eb/72eb7febb3fc83ad8e2b11ebf70e9e12.jpg',
      cost_min: '16.77',
    },
    {
      id: '847a79f0-43d6-4b14-9c48-714d065f73c2',
      name: 'Real Carbon Fiber Ring | Black | Slate Series',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4d/95/4d959b626586a22ebee582b4c8fd8aec.jpg',
      cost_min: '12.99',
    },
    {
      id: '7f8f7c10-8ca4-4503-8c03-ac1a5ffa9754',
      name: 'Irregular Design Opal Pearl Necklace',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/9c/dc/9cdc22ca5c9be3d0fa0c5b9704df75e8.jpg',
      cost_min: '48.00',
    },
    {
      id: 'dbb11068-851f-4295-a2b0-98c131b9d7d8',
      name: 'Freshwater Pearl Half Gold Bangle Bracelet',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/fa/4e/fa4e76f9acc113ddd90af974973354d3.jpg',
      cost_min: '52.00',
    },
    {
      id: '5af780d8-f505-4d91-9ee0-d3500da1a442',
      name: 'Freshwater Pearl and Pink Zircon Necklace',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/8f/cd/8fcddae11a0e3e935e42061bd1c65120.jpg',
      cost_min: '54.40',
    },
    {
      id: '46f4ba92-d025-47b8-8641-3ab795d7751e',
      name: 'Initial Edge Square Seamless Clip Charm',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/0d/24/0d246cabc81f804ea545158889d9a9c8.jpg',
      cost_min: '8.25',
    },
    {
      id: '0e1de5f9-6b49-48ee-8861-f59995974a64',
      name: 'Grove - White Howlite & Blackwood',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/0f/1d/0f1d85ee0596e935f295540500842525.jpg',
      cost_min: '11.37',
    },
    {
      id: 'f7ce3d68-81bb-476f-870c-00747d54636f',
      name: 'Dani Glitter Bands',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/91/db/91db9e9e36258e5fa2fa3ee610293fb3.jpg',
      cost_min: '16.20',
    },
    {
      id: '3d319984-d915-4f3b-a1da-7fed4af3ce62',
      name: 'Silk Wreath Hoop Earrings',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/3e/4b/3e4b61e0ca191386e36a32c5c49cd61f.jpg',
      cost_min: '36.00',
    },
    {
      id: '28eb007d-1e1b-489d-80af-c300a94fc608',
      name: 'Marquise Ear Climbers',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c2/62/c2628c09ae1a164557ee57e74f632aa1.jpg',
      cost_min: '22.80',
    },
    {
      id: '228b6c3b-9991-4e33-ad06-48d04b8d9c8f',
      name: 'Personalized Initial Necklace - Sterling Silver',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f3/cf/f3cfd13e132f65d43b3cbb0c3c76de9c.jpg',
      cost_min: '21.00',
    },
    {
      id: '02c342fa-5dda-4235-909c-040227413962',
      name: 'Raw Natural Crystals | 24 Karats Pendant Necklaces',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/64/e8/64e826995a15c86a4c0c14dbe0d140d5.webp',
      cost_min: '22.19',
    },
  ],
  'rts.consumerElectronics': [
    {
      id: 'a4a09dc7-3185-40a3-8355-e74310716f40',
      name: 'BSport – Bluetooth Sport Headphones With Dual-Microphone and NFC',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d4/f5/d4f57b382de4b1cef32c5b030a498753.jpg',
      cost_min: '11.99',
    },
    {
      id: '231ca3d0-580b-4e17-91b6-b3852155a769',
      name: 'Beeing - The Cutting-Edge True Wireless Earbuds With Qi-Enabled Wireless Charging Case',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/10/5a/105ad37d58c1c34f5ea76f968557233e.jpg',
      cost_min: '35.99',
    },
    {
      id: '91a41875-a653-4ce8-9dda-d5df605b5a10',
      name: 'Tesla Fridge 193Wh Portable Power Station',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4b/ab/4babc0a9d32adadc5ab3db4a064350d4.jpg',
      cost_min: '159.60',
    },
    {
      id: '735510f2-09da-4f77-aae8-95480dad199f',
      name: 'VR Shinecon 10.0 Helmet 3D Glasses Virtual Reality Casque for Smartphone Smart Phone Goggles Headset Viar Video Game Binoculars',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/15/f6/15f690e37d4601a4efaea29c5634831e.jpg',
      cost_min: '31.36',
    },
    {
      id: '26c02774-4a8d-43b0-b2bb-afe8332af0c5',
      name: 'NA9 1080P HD Wifi Mini Wireless Surveillance Camera IR Infrared Night Vision Motion Detection IP Camera Home Security Sm',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f9/14/f914c56788edf324c0c844035455ce1d.jpg',
      cost_min: '46.05',
    },
    {
      id: 'db25145c-f76a-4474-a382-56804f9e7014',
      name: 'SabertoothPro VC550 AutoPod Phone-Tablet Mount',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/69/86/69866129829db1b5cd0f6a1325d74ef8.png',
      cost_min: '23.99',
    },
    {
      id: 'dc8ad7ea-403d-42e0-a63a-d2e3c9646258',
      name: 'Sabertooth VLT350 Smart Voice Language Translator',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ec/38/ec3859edeb509c88270ac3b693aeab2f.png',
      cost_min: '38.99',
    },
    {
      id: 'ec4e1fab-f3ad-45a0-ad37-c5538e5998c7',
      name: 'TriVox - Triangle Bluetooth Wireless Portable Speaker',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f3/69/f369a22517c451447de915c10587ffc0.png',
      cost_min: '17.99',
    },
    {
      id: '99f79c33-d371-46e4-b36c-3269ff6c0774',
      name: 'ACOPower 240W Foldable Solar Panel With ProteusX 20A Charge Controller',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/2d/d8/2dd8bb8a375ed02c5dd42199d661fcee.jpg',
      cost_min: '461.16',
    },
    {
      id: 'c81a13b3-af41-4092-889a-61e705feeb94',
      name: 'SERENITY Wireless Sleep Mask Headphones Bluetooth 5.0 [Free Shipping]',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f8/f2/f8f2d7e724bbff3845f554a141e22718.png',
      cost_min: '23.99',
    },
    {
      id: '737ac684-b712-4141-b888-701743f53072',
      name: 'Macaron Earbuds - Light Green',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/07/2d/072dd7a2d4a455af60fe70524dab92f7.jpg',
      cost_min: '14.95',
    },
    {
      id: '8e091267-d9a7-4691-b9c1-ee35ab1c4158',
      name: 'WHALE With Nylon Strap – Bluetooth IPX7 Waterproof Portable Outdoor Speaker With 30W Stereo Sound and USB Charge Out',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/8e/58/8e58ce2b318069e76b51a7b62b794270.png',
      cost_min: '41.99',
    },
    {
      id: '3cd78cb0-f77d-4d7e-8035-8377d4408a72',
      name: 'Macaron Earbuds - Light Blue',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/33/d6/33d6fca382cb800fb504eb381a904fe7.jpg',
      cost_min: '14.95',
    },
  ],
  'rts.homeGarden': [
    {
      id: 'a4894d21-3467-4483-9a50-26825f1c9653',
      name: 'Kanye West Albums Minimal',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/e3/60/e360313194ba7fda5c17dbdee6e8c9a6.jpg',
      cost_min: '10.20',
    },
    {
      id: '080004d2-e3c2-4f9a-b725-0b34c4ee0e68',
      name: 'Grade a Amethyst Druzy Crystals',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/ef/5e/ef5e07515e3c9ebecf569a503c19728b.jpg',
      cost_min: '4.80',
    },
    {
      id: '53e942d7-de81-4e46-843a-bd1ba42a8e4f',
      name: 'Vintage Flower Tropical Leaves Cushion Cover',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/9d/c2/9dc22ebe47f71dfd4adfa778701f4d1a.jpg',
      cost_min: '13.92',
    },
    {
      id: 'f20c9c64-d8d2-4b66-a644-2f21061b9947',
      name: 'Blushing Rosé Gemstone Diffuser',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/82/a7/82a7b6c1d47141739e547778c30d10c8.jpg',
      cost_min: '39.60',
    },
    {
      id: '5ccd90de-8bf8-49de-ba98-dc5cf6cd6f83',
      name: 'Relax Sequin Cushion Cover',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d2/cf/d2cf55931176df5b674b8c2476a71623.png',
      cost_min: '13.19',
    },
    {
      id: '87c464d0-8deb-47fe-bd52-1810f74a6614',
      name: 'Sultan Peshkir Turkish Towels',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d3/73/d3730df81c7f8290c70860222b45c155.png',
      cost_min: '7.79',
    },
    {
      id: '8c856ae0-ccd2-429b-adaf-538af3f9fe6a',
      name: 'Laundry Detergent Strips',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/cb/e4/cbe4a9764d8e20f98ff02e4627099404.jpg',
      cost_min: '12.27',
    },
    {
      id: '5b6e8fdc-519c-4f62-9f0e-3d352dc45c74',
      name: 'Convoy S2+ Black  XML2 U2-1a AMC7135*3  2-Group 3/5-Mode EDC LED Flashlight',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/10/4a/104ab27773e022ff79d62bf22975a911.jpg',
      cost_min: '13.71',
    },
    {
      id: '4a1199b5-ea43-4d60-8ef4-095233cf6fed',
      name: 'Rose Gold Crystal Elixir Water Bottle With Tea Infuser 500ML',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f5/03/f5039e3234e3374157185d52fedae2eb.png',
      cost_min: '21.59',
    },
    {
      id: '9950588e-2c3a-4c92-89f4-76b7c7cc964d',
      name: 'Dish Soap Block',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ce/48/ce48263bcff9a2c3cad47c45eb79bfbb.jpg',
      cost_min: '8.39',
    },
    {
      id: '9df6e5c5-686a-4a12-9b0e-718773a0d6f1',
      name: 'Natural Handcrafted Grey Himalayan Salt Lamp 1.5-5kg',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/5f/c9/5fc9ff92bdef9d14b7cd9d781663bd20.png',
      cost_min: '16.79',
    },
    {
      id: 'a0951ae3-ca8e-4bfc-aad2-8444c15bdbdf',
      name: 'Geometric Cactus & Succulent Planter',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/05/5b/055b67233481c90c90446a0ece8b550d.jpg',
      cost_min: '36.00',
    },
    {
      id: 'c594c310-b664-4491-bc29-7ed7a6423a7a',
      name: 'Wooden Coasters - American Walnut / Set of 4 Coasters',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/80/f0/80f0e2497a9bffd0035dc376acdf202b.jpg',
      cost_min: '17.47',
    },
    {
      id: '0c0f5083-d281-46bf-a3e1-c0d9118446e9',
      name: 'ACOPower 30W Mono Solar Panel for 12 Volt Battery Charging',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f7/23/f723d14c01a9bc1c35b2b280d589394e.jpg',
      cost_min: '31.43',
    },
    {
      id: '55d0dc6a-7b1f-439e-9fb8-1427d8881b17',
      name: 'Blanket Wall Rack',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4e/5f/4e5f7b3d933b23722f6b7679df0902de.jpg',
      cost_min: '129.00',
    },
    {
      id: '08d13fdd-bfdd-4ffe-ae9d-e37e9575a24a',
      name: 'ORIA Digital Thermometer LCD Indoor Outdoor Thermometer Temperature Wireless Temperature Sensor Thermometer for Home Office Room',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/46/d4/46d42cf978dba4b8d20f0314f233652a.jpg',
      cost_min: '23.25',
    },
    {
      id: '75a7456b-e171-4a2d-9357-67e96ab6d4d8',
      name: 'Modern Feather Wooden Miniature Figurines',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/b3/93/b393c8467996d0dec2c24570ea69dfe0.jpg',
      cost_min: '16.27',
    },
    {
      id: '65e5d4f4-6b95-403f-981f-89c47df75998',
      name: 'Premium 100% Organic New Zealand Wool Dryer Balls',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c8/9c/c89cd885ea2fff25cfa76031b55e677d.png',
      cost_min: '14.40',
    },
    {
      id: 'bbed9e5a-4cde-4d55-aef7-8416748bf9ff',
      name: 'DaDa Bedding Soothing SeaFoam Sky Blue Cotton Fitted Bed Sheet W/Pillow Cases (JHW604)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/05/88/05885ada682460cd10e6f892bea64f00.jpg',
      cost_min: '19.50',
    },
    {
      id: 'cc0f08bd-5aba-4ad5-a5e7-f1c832452d58',
      name: "The Connoisseur's Set - Signature Glass Edition",
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/7d/fd/7dfd88f4b8c919dfca6c68faaabd886d.png',
      cost_min: '38.49',
    },
  ],
  'rts.kidsBabies': [
    {
      id: '946a676d-c414-4c1b-bdbb-286b00ec8dae',
      name: 'Baby Onesie - Looks Like Mr. Tee',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/2e/4d/2e4d0863aae3001edd52d1fdc9c43eb1.png',
      cost_min: '21.60',
    },
    {
      id: 'b7358e4d-a609-4398-ae44-ba16f33ae812',
      name: 'Peter Pan Collar Dress',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/11/94/119465f3def0feb349bfdd7678c425af.jpg',
      cost_min: '14.40',
    },
    {
      id: '65ecd400-564f-4ae7-9bb0-8451f7972a19',
      name: 'Wall Stickers - Wooden Toys',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/9e/26/9e26115d2e8e4b0bd65dd3286fe033e5.jpg',
      cost_min: '23.40',
    },
    {
      id: '2f6422c7-14bd-415f-9f5e-bd6c4715b402',
      name: 'Monkey the Curtain Holder',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/0d/b5/0db57b11f02b705dbdb7de844147eaee.jpg',
      cost_min: '12.00',
    },
    {
      id: '74fed2e1-d156-4ca4-8406-86fb3a328794',
      name: 'Bambini Infant White Gown',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/83/35/8335734c543d354f8abc0f6505ef20df.jpg',
      cost_min: '4.19',
    },
    {
      id: 'dcdcfc28-7dcf-47cc-9ff9-bd4d12bcb6e8',
      name: 'Lammy Plush Rattle by Happy Horse',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/eb/13/eb134a9b3b19022fb7d7181f3400a7a9.jpg',
      cost_min: '9.60',
    },
    {
      id: 'b607c22d-f838-45f3-8348-b2188d2d448a',
      name: 'Bambini Receiving Blanket',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f5/5a/f55a0c99af947b0c37a0a8dc63aa7fbf.jpg',
      cost_min: '5.39',
    },
    {
      id: 'a2127943-2e82-44d1-91af-39401dd0abfd',
      name: "Bambini Girl's Printed Tank Top",
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/59/57/595773526716c9e004f07e521faf6d30.jpg',
      cost_min: '6.59',
    },
    {
      id: '03a0a3c6-a153-440a-b979-8bab6bec3f1e',
      name: 'Baby Onesie - Mexican Dancing Dinosaur With Sombrero',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/cc/62/cc627e2df3055ab344cf64f3faa4f1b7.jpg',
      cost_min: '22.80',
    },
    {
      id: '786f88c2-90bb-4adf-884e-3619cb8f6650',
      name: 'Bambini Fleece Robe With Hoodie',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4a/d2/4ad22daecc2fe15954b8860a4395b7ad.jpg',
      cost_min: '5.99',
    },
    {
      id: '83a719db-fa62-44c0-9d6a-d21c55cc9913',
      name: 'A Wild Boy & a Wild Monster Infant Bodysuits Combo',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/fd/53/fd53867e738e116f93834e8d7ee8e8bd.jpg',
      cost_min: '31.80',
    },
    {
      id: '35d35375-fd60-46c8-aea9-45b1a3eceab2',
      name: 'RBG - Infant Bodysuit - Gray',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c4/73/c473ee0deb7808397cb0d9429097e191.png',
      cost_min: '22.80',
    },
    {
      id: '09c46beb-4116-49a1-af55-81325a71ba17',
      name: 'Bamboo Rayon Alien Hooded Turkish Towel:Little Kid',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/66/af/66af6964a5daa910d25f4cc7c2dd6936.jpg',
      cost_min: '20.99',
    },
    {
      id: '050d1ed8-7650-4b28-929e-b0fa84eac788',
      name: 'Baby Mobile - Hot Air Balloon',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/06/f3/06f3bb0b2a4f2a0ff249e77d5ac3e226.jpg',
      cost_min: '16.80',
    },
    {
      id: '14df3ef7-4510-46c7-a3c7-4b9da7cabbf2',
      name: 'Are You My Mother? Bamboo Muslin Newcastle Blanket',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/05/df/05dffa1d414202b7c8934187d44e6ca2.jpg',
      cost_min: '16.50',
    },
    {
      id: '77dea216-151c-4a1c-b9b2-c680f5248b24',
      name: 'Ruffled Collar Bodysuit',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/57/32/5732921265c8ed1466ee59c09658990d.jpg',
      cost_min: '11.70',
    },
    {
      id: 'f9337801-a70a-4be5-9a7c-95213fecd623',
      name: 'Rainbow Cushion',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/6b/de/6bde72562053703544765c75996e7fef.jpg',
      cost_min: '16.20',
    },
    {
      id: '5bef2be7-88e8-4779-b7c0-026a79af1d9d',
      name: 'Indigo Forest Bamboo Newcastle Mini Kimono Jumpsuit',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/bd/5f/bd5f71d2e8cf613fd685b46643827ad9.jpg',
      cost_min: '12.00',
    },
    {
      id: '6ebd0a14-3212-4c04-8d69-c4b9a857c9d1',
      name: 'Double Croissant Sweatshirt',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/29/3d/293de841cc8a771f300062015923574f.jpg',
      cost_min: '26.23',
    },
    {
      id: 'b4e40b61-a4e5-4a29-9f50-eab51ec1544e',
      name: 'Indigo Forest Bamboo Newcastle Mini Pants',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/19/d0/19d0fa9bd2049f40dc842671bef75ab4.jpg',
      cost_min: '15.00',
    },
  ],
  'rts.sportsEntertainment': [
    {
      id: '9646987e-0cd8-4026-b01f-17dd3b25186b',
      name: 'Nation Auspicious Clouds Pickleball Paddle',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/19/dd/19dd8ce199d4b0b9d84728c6fc1f9d89.jpg',
      cost_min: '23.20',
    },
    {
      id: '8c05ce80-522a-4c70-a243-979ce94e7115',
      name: 'Ashton Sports Bra - Navy Blue',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/a4/0d/a40d722d9c090250e9071fbac216e939.jpg',
      cost_min: '9.70',
    },
    {
      id: '4897e990-b5e7-48d1-9f6d-b861122a8cfe',
      name: 'Pendleton X Yune Yoga Spider Rock Mat',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/99/a7/99a7d47549fe11d6196a37acb90ebd8d.jpg',
      cost_min: '39.00',
    },
    {
      id: 'f465eb28-2165-46c9-81ea-ade1b4c67e74',
      name: "Women's CoastFlex Turtle Bay Capri Leggings",
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/de/07/de075e54135e9f9da3679f25a392ffe3.png',
      cost_min: '36.00',
    },
    {
      id: 'ca0f74e7-e760-42c9-ac69-a13813f1d6b5',
      name: 'CoastFlex Sport Olivia II Leggings',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/9c/e5/9ce5034c3ff6ae9c2b14fc1c209e7661.png',
      cost_min: '48.00',
    },
    {
      id: '734a218e-a952-4444-8bc5-30629dec46b3',
      name: 'Vintage Lattice Pickleball Paddle',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d8/7b/d87bde021ff8b4c75fb079c400b5e533.jpg',
      cost_min: '23.20',
    },
    {
      id: 'f85302b6-2c51-418b-83dd-82939237362f',
      name: 'Push Up Board; Multi-Functional Detachable Push Up Bar; Home Workout Accessories',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/72/ea/72ea0d828aa40b6051549a850e7aafd1.jpg',
      cost_min: '25.19',
    },
    {
      id: 'f40058c3-161c-43c6-b6d4-fb05dc31e8e1',
      name: 'Professional Gym Adjustable Jump Rope - Black',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/9f/0a/9f0a52f1f3854146542463df8953256b.jpg',
      cost_min: '5.07',
    },
    {
      id: '99a92c83-f44c-412d-9dd8-a5434ad553ef',
      name: 'Santa Monica Leggings - Black',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f3/6e/f36ed08c8b977120746ed0aa0554fcd1.jpg',
      cost_min: '9.70',
    },
    {
      id: '7b23005d-7f4b-4ce8-98c6-ecbaeb4f45ad',
      name: 'Resistance Training & Ab Bundle',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d3/2a/d32aae40a1d8b8f0c8093e1c7562a69f.jpg',
      cost_min: '117.87',
    },
    {
      id: '438445ef-ec70-4ca6-99aa-a95386b64bb6',
      name: 'Yoga Strap Pendleton Canyonlands',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ed/a2/eda21302480e3508acbd28a9ae38c319.jpg',
      cost_min: '11.70',
    },
    {
      id: '652275e2-086f-4123-b361-77344da466f0',
      name: 'Pure Plant Protein Chocolate',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/1b/84/1b841d142a9c138ebd0a7560a72d6f2a.png',
      cost_min: '33.00',
    },
    {
      id: 'e9521abb-d739-4429-bb96-8954a5c1ea98',
      name: 'Pure Creatine',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/65/47/654765303e583c352ff24d30d5e4974c.png',
      cost_min: '33.00',
    },
    {
      id: 'ba303b99-aa66-42a0-8dba-3ee26f0ae58b',
      name: 'Yoga Towel Pendleton Fire Legend',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/a8/7b/a87bfed0f59e88445662537ec8e4e8f2.jpg',
      cost_min: '29.70',
    },
    {
      id: '92068471-2bae-441c-8b75-b36988a3a840',
      name: 'OMSutra Studio Yoga Mat 6mm Deluxe',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/78/65/7865f5577559493658f0aa1079ed2418.jpg',
      cost_min: '31.84',
    },
    {
      id: 'cfc18d19-0f07-41b8-ba39-814a96dc2371',
      name: 'High Waisted Yoga Leggings - Navy Blue',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/fd/3d/fd3da34eba9ca292446988fc8717f106.jpg',
      cost_min: '22.10',
    },
    {
      id: '6b718ef1-a8a1-46ee-8a74-486253e668e9',
      name: 'Trois Seamless Sports Jacket - Black With Navy',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ed/10/ed10f89a558b613f0827a4da7803fcf3.jpg',
      cost_min: '18.50',
    },
    {
      id: '509433d8-c2d6-4865-852a-1bcad268d68d',
      name: 'Topiom Water Rowing Machine (Dark)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/61/1f/611f29601a165e05e977c5a5e30d08dc.jpg',
      cost_min: '419.40',
    },
  ],
  'rts.womensFashion': [
    {
      id: 'a14e0d98-8e8c-47a0-99b5-28e4d99ba508',
      name: 'BARRINGTON | Slim Diamond Shape Fashion Sunglasses',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/8f/fb/8ffb58fa03c1b8a52b3d0f0ce3b82ba4.jpg',
      cost_min: '11.50',
    },
    {
      id: '0dfe0ce7-28b8-4bf4-9918-7e8d55424898',
      name: 'Annalise Womens Leather Jacket',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/08/5a/085a97b27b23522d76dec27145f9a72d.jpg',
      cost_min: '143.40',
    },
    {
      id: '5df93cfa-c7cc-40aa-86f3-66d5de976bda',
      name: 'Short Sleeve Knot Tunic',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/76/04/7604496e5eb81aea3955d46275eff106.jpg',
      cost_min: '20.99',
    },
    {
      id: '3de3631e-029b-4171-82d5-487fa50b8033',
      name: 'Turtleneck Model 199611 Badu',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/2e/6c/2e6c69dbc4fd2e3572ce1dcbf316abb5.jpg',
      cost_min: '19.90',
    },
    {
      id: '63f11225-8b92-4d14-bac8-576b50defffc',
      name: 'Flip-Flops Model 198287 Step in Style',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c6/ac/c6ac7b5b2481039ced1b6a60ba26cdf7.jpg',
      cost_min: '11.90',
    },
    {
      id: '0ee010c3-642f-45d4-8aec-52b3b72f7042',
      name: 'Cami With Lace Trim White and Fuchsia',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/22/6b/226b6fa41f62308b02612233a788991a.jpg',
      cost_min: '32.94',
    },
    {
      id: '93cd8c7a-c12c-4bc2-a8c3-de72cd6b365e',
      name: 'Denim Jacket With Star Embellishment in Midwash',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/5f/1b/5f1b1cfbfb6e6f4a158e16d6cd64ebcc.jpg',
      cost_min: '50.94',
    },
    {
      id: '7803470a-9267-41c2-8e1c-e38531023c67',
      name: 'Faux Fur Long Casual Coat',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/e1/e0/e1e01b0ed9ab2227ebd0b69ff0b1a389.jpg',
      cost_min: '69.48',
    },
    {
      id: '9fe7e77e-697a-437e-ac36-e72626b2428b',
      name: 'Find Your Coast® Palm Soul Open Shoulder A-Line Dress',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/47/47/47477bc0524fb88f4e8d0929c9e8818c.jpg',
      cost_min: '53.40',
    },
    {
      id: 'c8f6cb1a-062a-4088-8fc5-73887459b307',
      name: 'Underestimate Me Black Cat T-Shirt',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/7d/74/7d74aca6c08b7c95469009825a61d967.png',
      cost_min: '17.39',
    },
    {
      id: '294f43c3-cc7c-4493-8cbe-fa6d11d9e836',
      name: 'Touka Knitted Shrug Scarf - Black',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/e8/0f/e80f437861125afce3620da46f8ddae3.jpg',
      cost_min: '36.40',
    },
    {
      id: 'de11ef88-6fbc-436b-a841-019d4523c300',
      name: 'Daoko Pleated Puff Long Sleeve Shirt - White',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/dd/49/dd49bec2325063ef17479a82163733fb.jpg',
      cost_min: '46.20',
    },
    {
      id: '68d99667-3ae3-44be-9ff8-3b274fc3838e',
      name: 'Warmest Plush Insulated Cuff Knit Pom Women Winter Beanie Hat Warm Wool Insulated Cap Winter Beanie Hat',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/30/82/308289c2f7a0e41a18400ae3a64d8325.jpg',
      cost_min: '7.20',
    },
    {
      id: 'e88826af-f6af-4739-af2b-35852d1fc1c0',
      name: 'Gloriana - Women Circle Half Frame Oversize Rhinestone Fashion Round Sunglasses',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/8b/e1/8be118f5cb1dbd90d8e6e8c400ddd111.jpg',
      cost_min: '14.00',
    },
    {
      id: '8db44a75-9ebc-4613-ac47-03294869994c',
      name: 'Boho Deep V-Neck Sleeveless Maxi Dress',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/86/3c/863c64b0c6d6cc9b0fdbc30593f2cb05.jpg',
      cost_min: '46.14',
    },
    {
      id: '1ff6b821-827c-4889-aa2e-d4bdde3b6596',
      name: 'Rhinestone Stone Cap',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/fd/fe/fdfe2f7fb9deb23ce986141eefec5e90.jpg',
      cost_min: '16.74',
    },
    {
      id: '9e70f6d9-1cf8-4c21-a979-5a99f933c7e1',
      name: 'Flip-Flops Model 194121 Step in Style',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/cc/00/cc008b785b2707e51e691d816441b942.jpg',
      cost_min: '23.90',
    },
    {
      id: '8fbdbf41-3a30-4acf-af35-e013893a0e8e',
      name: 'Snow Boots Model 202196 Step in Style',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/38/3c/383c712e9bdb874d5e740bd678fdbb1e.jpg',
      cost_min: '20.90',
    },
    {
      id: '3cc222d5-372a-44d7-8b16-968068abe966',
      name: 'Sport Shoes Model 198455 Step in Style',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/de/f3/def3526a154b4f4b2efc60227c660b5e.jpg',
      cost_min: '34.90',
    },
    {
      id: '23fd1e40-51e0-4534-87cf-9a8eda897d67',
      name: 'Slippers Model 191632 Step in Style',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/10/cc/10cc2ca84753ea2978b91311c31f35f3.jpg',
      cost_min: '21.90',
    },
  ],
  'rts.toysHobbies': [
    {
      id: '61b240a4-f57e-4481-b9ab-2b45b33db95f',
      name: 'Iimo 3-In-1 Foldable Tricycle With Canopy',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/30/a2/30a25aa3ba5e5be7626b796e69ab6b8a.jpg',
      cost_min: '196.00',
    },
    {
      id: 'dcba01b6-b316-4e4a-8e96-89e64b051894',
      name: 'Skillmatics Space Explorers - Teach Kids About Space - Write &amp; Wipe Educational Games for Children',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/df/cc/dfcc808087e03f84cdfa46af002a5046.jpg',
      cost_min: '23.99',
    },
  ],
  'rts.bagsLuggage': [
    {
      id: '8f6f3f06-ec4f-4c42-8764-fd8bc02ffb48',
      name: 'Oversize Hobo Bag for Women Boho Purses and Handbags Fringe Big',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/9a/2f/9a2f42db29a70c7b736e677fde690b7f.jpg',
      cost_min: '41.99',
    },
    {
      id: '3fbfcd8f-9447-43c5-9621-abaac14b6ddc',
      name: 'Causal Hobo Bag for Women Vegan Leather With Crossbody Long Strap in Tan, Blue, Grey, Black',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/50/15/5015c8c0e6f2f28de3091cc28f8a25ea.jpg',
      cost_min: '41.94',
    },
    {
      id: '648ae142-3aa6-4fed-b36e-2b41b57610c6',
      name: 'Backpack Purse for Women Utility Big Backpack Purse Vegan Leather Antique Tone',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c5/61/c5611df91f51624ed53abead15edf681.jpg',
      cost_min: '41.21',
    },
    {
      id: '59458e49-a3af-4314-80f2-8416812475f2',
      name: 'Luxury Alligator Leather Handbags',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/97/11/971154bcad85803be2016882a03d099f.jpg',
      cost_min: '56.89',
    },
    {
      id: '15b0d2f3-8d17-44bb-b202-bc7fa0e4395f',
      name: 'Luxury Leather Bucket Acrylic Handle Shoulder Bag',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/69/b3/69b3a316fd84f46611dad33a13dec6d1.jpg',
      cost_min: '50.18',
    },
    {
      id: 'eeabf9f3-43bb-42b8-accd-dc85d4e7c293',
      name: 'Shoulder Cross Chain Strap Handbag',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/15/86/1586fd0a63ed0740779716b693bb2a5d.jpg',
      cost_min: '43.46',
    },
    {
      id: '08e81f99-fb6f-4187-9027-079de6ef6b22',
      name: '005 - Leather Wallet With Detachable Wristlet',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/72/7e/727e06fc3034a44473cf80ca1f5dfcd9.jpg',
      cost_min: '19.35',
    },
    {
      id: '796fbb3a-ba54-468e-a3e7-d2cc45709888',
      name: 'Hdg2000 - Double Zip Around Wallet',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/36/34/3634b96dc02565fe4b45976c975a9060.jpg',
      cost_min: '9.00',
    },
    {
      id: '5f442e24-8bd6-4c79-8591-479e05f4f872',
      name: 'Genuine Leather Bag for Female Bag Shoulder Bag Large Capacity With Contrast Color Pattern Tote',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/53/82/538241a8842a2be7e17d08991edbb649.jpg',
      cost_min: '64.90',
    },
    {
      id: '6a996cba-aed2-460d-be90-c6067599a444',
      name: 'Pyramid Shape Tassel Wristlet Leather Bag',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c7/45/c7452abee4fafdcc00e240eaff6dfb75.jpg',
      cost_min: '26.10',
    },
    {
      id: 'cc5d0d07-315c-442d-88ba-486a2ef74fe9',
      name: 'Diamond Evening Clutch Bag for Women Wedding Golden Clutch Purse Chain Shoulder Bag Small Party Handbag With Metal Handl',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/63/a5/63a599de2f944d38704e71258eb397c7.jpg',
      cost_min: '66.60',
    },
    {
      id: 'dfed20fd-e60b-4fe5-8258-e14eb19ef5b1',
      name: 'Kate - Blue Vegan Basket Weave Bag',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/76/e1/76e174cf3c259b381096b57fd47e7b96.jpg',
      cost_min: '100.80',
    },
    {
      id: 'acbee3af-72a0-439b-95d6-6e737c38d2c3',
      name: 'Kiwi Small Leather Backpack',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/a0/d1/a0d13cc2559871d8aa9450151afc5bfa.jpg',
      cost_min: '57.20',
    },
    {
      id: 'a897ce02-79ce-41c1-bacc-c06b716120e4',
      name: 'Leopard Printed Tote Bag',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/fa/9f/fa9f0c69c4a5527c253a5f1886de0de0.jpg',
      cost_min: '9.90',
    },
    {
      id: 'c513f898-8109-4961-8c0d-302b363442ca',
      name: 'Naomi - Yellow Vegan Leather Tote Bag',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ea/d3/ead3a3ba8c936a18f54c77f3662fd55b.jpg',
      cost_min: '105.00',
    },
  ],
  'rts.cellphonesTelecommunications': [
    {
      id: '279320ab-b0e3-4ef0-947d-6455e4f8036d',
      name: 'Oak Wood Phone Case',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/aa/b4/aab4f65a46b5f5ceaa04f38c6c601615.jpg',
      cost_min: '22.38',
    },
    {
      id: 'c63bae53-9010-47bb-9ed7-2dc3669b8dbc',
      name: 'Wireless Charger With Organic and Wood Material',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/30/ae/30ae4ff6b7a1e5b61dfb2ea5148d6ed4.jpg',
      cost_min: '11.16',
    },
    {
      id: 'cc814da8-7eb5-4065-94c0-4902812aa3c7',
      name: 'iPhone | Real Aramid Fiber Case | GHOST Series',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/82/8c/828c4f8277dcdf3b5ef9d875feaac008.jpg',
      cost_min: '29.24',
    },
    {
      id: '11af8ec3-d669-4d6b-b2ca-c371f28272cb',
      name: 'Apple AirPods | Real Forged Carbon Fiber Case',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/86/62/866278369871b432f1a2b754b3f282d0.jpg',
      cost_min: '38.99',
    },
    {
      id: '8ff9dd7f-8fb2-444d-bf1d-4237945afd33',
      name: 'PowerGlow - Jabees PowerGlow 4-In-1 Foldable Wireless Charging Station With LED Night Light',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c8/5b/c85bd804b7d2637b0eb42fb46d0994a0.png',
      cost_min: '17.99',
    },
    {
      id: 'e8cd2757-d9cc-4226-bd3d-889b615ba8c2',
      name: 'Portable Zoom Binoculars With FMC Lens Low Light Night Vision for Bird Watching Hunting Sports',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/43/74/437408d9259b7ce88fed5c75cb0336e5.jpg',
      cost_min: '48.70',
    },
    {
      id: '058c0341-6a02-415a-b17f-9be8d94a7d0f',
      name: 'HyperFuel 100W Back-Up Power Bank for Laptops and Other Devices (20,000mAh)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f2/7d/f27d364883e67082ef984a158536fec0.png',
      cost_min: '59.99',
    },
    {
      id: '21cf11c2-0bd5-466e-90fc-46f8dfb4a977',
      name: 'Real Carbon Fiber Key Holder & Organizer',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d4/75/d47582148dd9519f9931989c354d1e5f.jpg',
      cost_min: '27.29',
    },
  ],
};
